!(function (t, e, i, n, s, o, a, r, d, l, h, c, u, p) {
    function m() {
        (this.registered = {}), (this.instances = []), (this.extensions = { "*": [] });
    }
    function f() {
        this.extensions.forEach(
            function (t) {
                this.extend(t);
            }.bind(this)
        );
    }
    function g() {
        (this.$document = t(document)),
            (this.namespace = ".section-js-events"),
            document.addEventListener(
                "shopify:section:load",
                function (t) {
                    var e = t.detail.sectionId,
                        i = t.target.querySelector('[data-section-id="' + e + '"]'),
                        n = i.getAttribute("data-section-type");
                    this.load(n, i);
                }.bind(this)
            );
    }
    function v(e) {
        (this.container = e.container),
            (this.$container = t(this.container)),
            (this.id = e.id),
            (this.namespace = "." + e.id),
            (this.extensions = e.extensions || []),
            (this.$eventBinder = this.$container),
            _.call(this),
            b.call(this),
            S.call(this);
    }
    function _() {
        this.extensions.forEach(
            function (t) {
                this.extend(t);
            }.bind(this)
        );
    }
    function b() {
        t(document)
            .on("shopify:section:unload" + this.namespace, y.bind(this))
            .on("shopify:section:select" + this.namespace, w.bind(this))
            .on("shopify:section:deselect" + this.namespace, C.bind(this))
            .on("shopify:block:select" + this.namespace, $.bind(this))
            .on("shopify:block:deselect" + this.namespace, k.bind(this));
    }
    function S() {
        this.on("section_load", this.onLoad.bind(this)),
            this.on("section_unload", this.onUnload.bind(this)),
            this.on("section_select", this.onSelect.bind(this)),
            this.on("section_deselect", this.onDeselect.bind(this)),
            this.on("block_select", this.onBlockSelect.bind(this)),
            this.on("block_deselect", this.onBlockDeselect.bind(this));
    }
    function y(e) {
        this.id === e.detail.sectionId && ((e.type = "section_unload"), this.trigger(e), this.off(this.namespace), z.off(this.namespace), t(document).off(this.namespace), t(window).off(this.namespace), o(z.instances, { id: this.id }));
    }
    function w(t) {
        this.id === t.detail.sectionId && ((t.type = "section_select"), this.trigger(t));
    }
    function C(t) {
        this.id === t.detail.sectionId && ((t.type = "section_deselect"), this.trigger(t));
    }
    function $(t) {
        this.id === t.detail.sectionId && ((t.type = "block_select"), this.trigger(t));
    }
    function k(t) {
        this.id === t.detail.sectionId && ((t.type = "block_deselect"), this.trigger(t));
    }
    function x(e, i) {
        (this.$element = t(e)),
            (this.$slides = t(Ft.slides, this.$element)),
            (this.config = t.extend({}, Ot, i)),
            (this.isDraggable = !0),
            this._setCurrentSlide(t(Ft.activeSlide, this.$element)),
            this._assignTouchHandlers(),
            (this.bindedOnFocus = this._onFocus.bind(this)),
            (this.bindedOnBlur = this._onBlur.bind(this)),
            this.$slides.length && (this.$slides[0].addEventListener("focus", this.bindedOnFocus, !0), this.$slides[0].addEventListener("blur", this.bindedOnBlur, !0));
    }
    function T(t) {
        var e;
        switch (t) {
            case "ZERO_RESULTS":
                e = te.zeroResults;
                break;
            case "OVER_QUERY_LIMIT":
                e = te.overQueryLimit;
                break;
            case "REQUEST_DENIED":
                e = te.requestDenied;
                break;
            case "UNKNOWN_ERROR":
                e = te.geocodeUnknownError;
                break;
            default:
                e = te.geocodeUnknownError;
        }
        return e;
    }
    (t = "default" in t ? t.default : t),
        (e = "default" in e ? e.default : e),
        (i = "default" in i ? i.default : i),
        (n = "default" in n ? n.default : n),
        (o = "default" in o ? o.default : o),
        (a = "default" in a ? a.default : a),
        (r = "default" in r ? r.default : r),
        (d = "default" in d ? d.default : d),
        (l = "default" in l ? l.default : l),
        (h = "default" in h ? h.default : h),
        (c = "default" in c ? c.default : c),
        (u = "default" in u ? u.default : u),
        (p = "default" in p ? p.default : p),
        (m.prototype = {
            register: function (e, i, n) {
                function s(i, n) {
                    (this.name = e.toLowerCase()), (this.container = i), (this.$container = t(i)), (this.extensions = n), f.call(this);
                }
                (s.classname = i), (s.constructor = s), (s.prototype = Object.create(f.prototype)), t.extend(s.prototype, n), (this.registered[e] = s);
            },
            extend: function (t, e) {
                "*" === t ? ((t = Object.keys(this.registered)), t.push("*")) : "string" == typeof t && (t = [t]),
                    t.forEach(
                        function (t) {
                            (this.extensions[t] = this.extensions[t] || []),
                                this.extensions[t].push(e),
                                void 0 !== this.registered[t] &&
                                    "*" !== t &&
                                    this.instances.forEach(function (i) {
                                        i.name === t && i.extend(e);
                                    });
                        }.bind(this)
                    );
            },
            load: function (t) {
                "*" === t ? (t = Object.keys(this.registered)) : "string" == typeof t && (t = [t]), t.forEach(this._loadTemplate.bind(this));
            },
            _loadTemplate: function (e) {
                var n,
                    s,
                    o = this.registered[e],
                    a = i(this.instances, { name: e });
                void 0 === o ||
                    a ||
                    ((n = "*" === o.classname ? document.body : document.querySelector("body." + o.classname)) &&
                        ((s = this.extensions["*"].concat(this.extensions[e] || [])), (a = new o(n, s)), t.isFunction(a.onLoad) && a.onLoad(n), this.instances.push(a)));
            },
        }),
        (f.prototype = {
            extend: function (i) {
                var n = i.init;
                this.extensions.push(i), t.isFunction(n) && (i = e(i, "init")), t.extend(this, i), n.apply(this);
            },
        });
    var P = new m(),
        A = { disableScroll: "disable-scroll", isTouch: "is-touch" },
        B = {
            pointerEventToXY: function (t) {
                var e;
                return (e = t.originalEvent.touches ? t.originalEvent.touches[0] || t.originalEvent.changedTouches[0] : t), { x: e.pageX, y: e.pageY };
            },
            promiseRepeatSeries: function (t, e) {
                return (
                    e--,
                    t().then(
                        function () {
                            if (e) return this.promiseRepeatSeries(t, e);
                        }.bind(this)
                    )
                );
            },
            mapPromiseSeries: function (e, i, n) {
                function s(e, s) {
                    return t.Deferred(function (t) {
                        setTimeout(function () {
                            t.resolve(i(e, s));
                        }, n);
                    });
                }
                var o = t.Deferred().resolve();
                return (
                    t.each(e, function (t, e) {
                        o = o.then(function () {
                            return "number" == typeof n ? s(t, e) : i(t, e);
                        });
                    }),
                    o
                );
            },
            promiseAnimationEnd: function (e) {
                var i = "animationend webkitAnimationEnd oAnimationEnd",
                    n = ["animation-duration", "-moz-animation-duration", "-webkit-animation-duration", "-o-animation-duration"],
                    s = 0,
                    o = t.Deferred().resolve();
                return (
                    t.each(n, function (t, i) {
                        s || (s = parseFloat(e.css(i)));
                    }),
                    s > 0 &&
                        (o = t.Deferred(function (t) {
                            e.on(i, function (n) {
                                n.target === e[0] && (e.off(i), t.resolve());
                            });
                        })),
                    o
                );
            },
            promiseTransitionEnd: function (e) {
                var i = "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
                    n = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"],
                    s = 0,
                    o = t.Deferred().resolve();
                return (
                    t.each(n, function (t, i) {
                        s || (s = parseFloat(e.css(i)));
                    }),
                    s > 0 &&
                        (o = t.Deferred(function (t) {
                            e.on(i, function (n) {
                                n.target === e[0] && (e.off(i), t.resolve());
                            });
                        })),
                    o
                );
            },
            isLocalStorageSupported: function () {
                var t = "localStorageTest";
                try {
                    return localStorage.setItem(t, t), localStorage.removeItem(t), !0;
                } catch (t) {
                    return !1;
                }
            },
            isSessionStorageSupported: function () {
                var t = "sessionStorageTest";
                try {
                    return sessionStorage.setItem(t, t), sessionStorage.removeItem(t), !0;
                } catch (t) {
                    return !1;
                }
            },
            disableTabbingOfChildren: function (e) {
                t(e).each(function (e, i) {
                    t("a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]", i).attr("tabindex", "-1");
                });
            },
            enableTabbingOfChildren: function (e) {
                t(e).each(function (e, i) {
                    t(
                        "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex]:not(.plyr):not([data-product-media-wrapper]), *[contenteditable]",
                        i
                    ).removeAttr("tabindex");
                });
            },
            isiOSSafari: function () {
                var t = window.navigator.userAgent,
                    e = Boolean(t.match(/iPad/i)) || Boolean(t.match(/iPhone/i)),
                    i = Boolean(t.match(/WebKit/i));
                return e && i && !t.match(/CriOS/i);
            },
            disableScrollBody: function () {
                document.body.scrollHeight - window.innerHeight != 0 && t("html").addClass(A.disableScroll);
            },
            enableScrollBody: function () {
                t("html").removeClass(A.disableScroll);
            },
            updateUrlParameter: function (t, e, i) {
                var n = new RegExp("([?&])" + e + "=.*?(&|$)", "i"),
                    s = -1 === t.indexOf("?") ? "?" : "&";
                return t.match(n) ? t.replace(n, "$1" + e + "=" + i + "$2") : t + s + e + "=" + i;
            },
            cookiesEnabled: function () {
                var t = navigator.cookieEnabled;
                return t || ((document.cookie = "testcookie"), (t = -1 !== document.cookie.indexOf("testcookie"))), t;
            },
            onFirst: function (e, i) {
                this.on(e, i),
                    this.each(function () {
                        var i = t._data(this, "events")[e.split(".")[0]],
                            n = i.pop();
                        i.splice(0, 0, n);
                    });
            },
            promiseStylesheet: function (e) {
                var i = e || theme.stylesheet;
                return (
                    void 0 === this.stylesheetPromise &&
                        (this.stylesheetPromise = t.Deferred(function (t) {
                            var e = document.querySelector('link[href="' + i + '"]');
                            e.loaded && t.resolve(),
                                onloadCSS(e, function () {
                                    t.resolve();
                                });
                        })),
                    this.stylesheetPromise
                );
            },
            isMobile: function () {
                function e() {
                    return (i = t(window).outerWidth() < theme.mediaQuerySmall);
                }
                var i = !1;
                return (
                    (this.isMobile = function () {
                        return i;
                    }),
                    (t.fn.onFirst = this.onFirst),
                    t(window).onFirst("resize", e),
                    e()
                );
            },
            isTablet: function () {
                function e() {
                    var e = t(window).outerWidth();
                    return (i = e > theme.mediaQuerySmall && e < theme.mediaQueryMedium);
                }
                var i = !1;
                return (
                    (this.isTablet = function () {
                        return i;
                    }),
                    (t.fn.onFirst = this.onFirst),
                    t(window).onFirst("resize", e),
                    e()
                );
            },
            isInOrAboveViewport: function (t) {
                var e = t.getBoundingClientRect();
                return (e.top + 50 >= 0 && e.top + 50 <= window.innerHeight) || (e.bottom + 50 >= 0 && e.bottom + 50 <= window.innerHeight) || (e.top + 50 < 0 && e.bottom + 50 > window.innerHeight) || e.bottom < 0;
            },
            isTouch: function () {
                var e = !1;
                return (
                    (this.isTouch = function () {
                        return e;
                    }),
                    t(document).one("touchstart", function () {
                        (e = !0), t("html").addClass(A.isTouch);
                    }),
                    e
                );
            },
            keyboardKeys: { TAB: 9, ENTER: 13, SPACE: 32, LEFTARROW: 37, RIGHTARROW: 39 },
        },
        E = { elementsToAnimate: "[data-animate]" },
        I = { animated: "has-animated", animationsDisabled: "animations--disabled" };
    P.register("Page animations", "*", {
        onLoad: function () {
            if (((this.animationNamespace = ".animations"), (this.$elementsToAnimate = t(E.elementsToAnimate, this.$container)), 0 !== this.$elementsToAnimate.length)) {
                var e = "scroll" + this.animationNamespace;
                Shopify.designMode && (e += " touchmove" + this.animationNamespace),
                    t(window).on(e, n(this._animateElementsInViewport.bind(this), 200)),
                    t(window).on("resize" + this.animationNamespace, n(this._animateElementsInViewport.bind(this), 200)),
                    Shopify &&
                        Shopify.designMode &&
                        (t(document).on("shopify:section:load shopify:section:select", this._onSectionSelect.bind(this)), t(document).on("shopify:section:unload shopify:section:deselect", this._onSectionDeselect.bind(this))),
                    B.promiseStylesheet().then(this._animateElementsInViewport.bind(this));
            }
        },
        _animateElementsInViewport: function () {
            (this.$elementsToAnimate = this.$elementsToAnimate.map(function (e, i) {
                return B.isInOrAboveViewport(i)
                    ? (requestAnimationFrame(function () {
                          t(i).addClass(I.animated), t(i).trigger("animate_element", [i]);
                      }),
                      null)
                    : i;
            })),
                0 === this.$elementsToAnimate.length && t(window).off(this.animationNamespace);
        },
        _onSectionSelect: function () {
            t(document.body).addClass(I.animationsDisabled);
        },
        _onSectionDeselect: function (e) {
            t(document.body).removeClass(I.animationsDisabled), t(e.target).find(E.elementsToAnimate).addClass(I.animated);
        },
    });
    var M = { socialSharing: ".social-sharing", socialSharingToggle: ".social-sharing__toggle", linkList: ".social-sharing__item-list" },
        D = { socialSharingAction: "social-sharing--active" },
        F = {
            init: function () {
                (this.$elements = t(M.socialSharing, this.$container)),
                    (this.clicked = !1),
                    t(M.socialSharingToggle, this.$container)
                        .on("click", this._onClick.bind(this))
                        .one("click", function () {
                            this.clicked = !0;
                        }),
                    this.$container.on("section_unload", this.destroySocialSharing.bind(this));
            },
            showSocialSharing: function () {
                t(M.socialSharing, this.$container).addClass(D.socialSharingAction),
                    t(M.socialSharingToggle, this.$container).attr("aria-expanded", !0),
                    t(M.linkList, this.$container).attr("aria-hidden", !1),
                    B.enableTabbingOfChildren(t(M.linkList, this.$container));
            },
            hideSocialSharing: function () {
                t(M.socialSharing, this.$container).removeClass(D.socialSharingAction),
                    t(M.socialSharingToggle, this.$container).attr("aria-expanded", !1),
                    t(M.linkList, this.$container).attr("aria-hidden", !0),
                    B.disableTabbingOfChildren(t(M.linkList, this.$container));
            },
            destroySocialSharing: function () {
                t(M.socialSharingToggle, this.$container).off();
            },
            _onClick: function (e) {
                "true" === t(e.currentTarget).attr("aria-expanded") ? this.hideSocialSharing() : this.showSocialSharing();
            },
        },
        H = {
            articleContentWrapper: ".article__wrapper",
            articleShareDesktop: ".article__share-desktop",
            articleShareMobile: ".article__share-mobile",
            articleShareDesktopWrapper: ".article__share-desktop-wrapper",
            socialSharing: ".social-sharing",
        },
        L = { shareFixed: "article__share-desktop--fixed", shareBottom: "article__share-desktop--bottom" },
        O = { shareExpandedHeight: 350 };
    P.register("Article Template", "template-article", {
        onLoad: function () {
            this.extend(F),
                t(window).on("scroll", this.setSharePosition.bind(this)).on("resize", this.updateMeasurements.bind(this)),
                B.promiseStylesheet().then(
                    function () {
                        this.updateMeasurements();
                    }.bind(this)
                );
        },
        setSharePosition: function () {
            if (!B.isMobile() && !B.isTablet()) {
                var e = t(window).scrollTop();
                requestAnimationFrame(
                    function () {
                        e > this.fixedTop
                            ? e > this.fixedBottom
                                ? t(H.articleShareDesktop).removeClass(L.shareFixed).addClass(L.shareBottom)
                                : t(H.articleShareDesktop).addClass(L.shareFixed).removeClass(L.shareBottom)
                            : t(H.articleShareDesktop).removeClass(L.shareFixed).removeClass(L.shareBottom),
                            this.clicked || (e > this.fixedBottom - O.shareExpandedHeight ? this.showSocialSharing() : this.hideSocialSharing());
                    }.bind(this)
                );
            }
        },
        updateMeasurements: function () {
            (this.fixedTop = t(H.articleContentWrapper).offset().top),
                (this.fixedBottom = this.fixedTop + t(H.articleContentWrapper).height() - t(H.articleShareDesktopWrapper).height()),
                (this.windowHeight = t(window).outerHeight()),
                this.setSharePosition();
        },
    });
    var V = {
            addressCountrySelect: ".address-country-selector",
            newToggle: ".address-new-toggle",
            newAddressContainer: ".new-address",
            editToggle: ".address-edit-toggle",
            editAddressContainer: ".edit-address",
            editAddressContainerId: "#EditAddress_",
            deleteAddress: ".address-delete",
            currentAddresses: ".current-addresses",
            currentAddress: "#CurrentAddress_",
            currentAddressesItem: ".current-addresses__item",
        },
        N = { newAddressHide: "new-address--hidden", editAddressShow: "edit-address--show" };
    P.register("Customer Addresses Template", "template-customers-addresses", {
        onLoad: function (e) {
            var i = (this.$container = t(e)),
                n = t(theme.countryOptionTags).filter("option"),
                s = t(V.addressCountrySelect, i),
                o = t(V.newAddressContainer, i),
                a = t(V.editAddressContainer, i);
            s.each(
                function (e, s) {
                    var o = this._populateCountrySelect(s, n),
                        a = this._fetchCurrentProvinces(o),
                        r = t(o.attr("data-province-select"), i),
                        d = r.data("default");
                    this._populateProvinceSelect(r, a, d);
                }.bind(this)
            ),
                t(V.newToggle).on("click", this._onNewAddressClick.bind(this)),
                t(V.editToggle).on("click", this._onEditAddressClick.bind(this)),
                t(V.deleteAddress).on("click", this._onDeleteAddressClick.bind(this)),
                0 !== t("div.errors", o).length && o.removeClass(N.newAddressHide),
                a.each(function () {
                    0 !== t("div.errors", this).length && t(this).addClass(N.editAddressShow);
                });
        },
        _populateCountrySelect: function (e, n) {
            var s = t(e),
                o = s.data("default"),
                a = n[0];
            return (
                "string" == typeof o &&
                    "" !== o &&
                    (a = i(n, function (t) {
                        return t.text === o;
                    })),
                s.html(n.clone()).val(a.value).on("change", this._onCountrySelectChange.bind(this))
            );
        },
        _populateProvinceSelect: function (e, i, n) {
            var s = e.parent(),
                o = i.map(this._createProvinceOption),
                a = n || t(o[0]).val();
            return o.length ? s.show() : s.hide(), e.html(o).val(a);
        },
        _createProvinceOption: function (e) {
            return t("<option>").attr({ value: e[1] }).text(e[1]);
        },
        _fetchCurrentProvinces: function (t) {
            return t.find(":selected").data("provinces") || [];
        },
        _onCountrySelectChange: function (e) {
            var i = t(e.target),
                n = this._fetchCurrentProvinces(i),
                s = t(i.data("province-select"));
            this._populateProvinceSelect(s, n);
        },
        _onNewAddressClick: function () {
            t(V.newAddressContainer, this.$container).toggleClass(N.newAddressHide);
        },
        _onEditAddressClick: function (e) {
            var i = t(e.target).data("form-id");
            t(V.editAddressContainerId + i, this.$container).toggleClass(N.editAddressShow);
        },
        _onDeleteAddressClick: function (e) {
            var i = t(e.target),
                n = i.data("form-id"),
                s = i.data("address-url"),
                o = i.data("confirm-message"),
                a = t(V.currentAddress + n, this.$container);
            confirm(o) && (t.post(s, { _method: "delete" }), a.remove(), t(V.currentAddressesItem).length || (t(V.currentAddresses, this.$container).remove(), t(V.newAddressContainer, this.$container).removeClass(N.newAddressHide)));
        },
    });
    var R = { recoverPasswordForm: "#RecoverPasswordForm", customerLoginForm: "#CustomerLoginForm", hideRecoverPasswordLink: "#HideRecoverPasswordLink", showRecoverPasswordLink: "#RecoverPassword" };
    P.register("Customer Login Template", "template-customers-login", {
        onLoad: function (e) {
            var i = (this.$container = t(e));
            this.checkUrlHash(), this.resetPasswordSuccess(), t(R.showRecoverPasswordLink, i).on("click", this.onShowHidePasswordForm.bind(this)), t(R.hideRecoverPasswordLink, i).on("click", this.onShowHidePasswordForm.bind(this));
        },
        onShowHidePasswordForm: function (t) {
            t.preventDefault(), this.toggleRecoverPasswordForm();
        },
        checkUrlHash: function () {
            "#recover" === window.location.hash && this.toggleRecoverPasswordForm();
        },
        toggleRecoverPasswordForm: function () {
            t(R.recoverPasswordForm).toggleClass("hide"), t(R.customerLoginForm).toggleClass("hide");
        },
        resetPasswordSuccess: function () {
            t(".reset-password-success").length && t("#ResetSuccess").removeClass("hide");
        },
    }),
        Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
    var W = {
        wrapTable: function () {
            t(".rte table").wrap('<div class="rte__table-wrapper"></div>');
        },
        iframeReset: function () {
            var e = t('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                i = e.add(".rte iframe#admin_bar_iframe");
            e.each(function () {
                t(this).wrap('<div class="video-wrapper"></div>');
            }),
                i.each(function () {
                    this.src = this.src;
                });
        },
        imageLink: function () {
            t(".rte a:has(img)").addClass("image-link");
        },
    };
    P.register("Page Helpers", "*", {
        onLoad: function () {
            this.pageLinkFocus(), this.rteFixes(), this.disableOutlineOnClick(), this.checkIfMobileOS();
        },
        pageLinkFocus: function () {
            s.focusHash({ className: "js-focus-hidden" }), s.bindInPageLinks({ className: "js-focus-hidden", ignore: "[data-link-no-focus]" });
        },
        rteFixes: function () {
            W.wrapTable(), W.iframeReset(), W.imageLink();
        },
        disableOutlineOnClick: function () {
            var e = { outlineDisabled: "outline-disabled" };
            t("html").addClass(e.outlineDisabled),
                t(document).on("keyup", function () {
                    t("html").removeClass(e.outlineDisabled);
                }),
                t(document).on("click", function (i) {
                    t("html").toggleClass(e.outlineDisabled, !t(i.target).is("input, textarea, select, button"));
                });
        },
        checkIfMobileOS: function () {
            var e = navigator.userAgent.toLowerCase(),
                i = /ipad|iphone|ipod/.test(e) && !window.MSStream,
                n = /android/.test(e);
            i && t("html").addClass("is-mobile-os").addClass("is-ios"), n && t("html").addClass("is-mobile-os").addClass("is-android");
        },
    });
    var q = {
        pageLinkFocus: function (t) {
            function e() {
                t.first().removeClass(i).removeAttr("tabindex");
            }
            var i = "js-focus-hidden";
            t.first().attr("tabIndex", "-1").focus().addClass(i).one("blur", e);
        },
        forceFocus: function (t) {
            t.focus(),
                t.is(document.activeElement) ||
                    t
                        .attr("tabindex", "0")
                        .focus()
                        .one("blur", function () {
                            t.removeAttr("tabindex");
                        });
        },
        focusHash: function () {
            var e = window.location.hash;
            e && document.getElementById(e.slice(1)) && this.pageLinkFocus(t(e));
        },
        bindInPageLinks: function () {
            t("a[href*=#]").on(
                "click",
                function (e) {
                    this.pageLinkFocus(t(e.currentTarget.hash));
                }.bind(this)
            );
        },
        trapFocus: function (e) {
            var i = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$elementToFocus || (e.$elementToFocus = e.$container),
                e.$container.attr("tabindex", "-1"),
                e.$elementToFocus.focus(),
                t(document).on(i, function (t) {
                    e.$container[0] === t.target || e.$container.has(t.target).length || e.$container.focus();
                });
        },
        removeTrapFocus: function (e) {
            var i = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$container && e.$container.length && e.$container.removeAttr("tabindex"), t(document).off(i);
        },
    };
    t.fn.prepareTransition = function () {
        return this.each(function () {
            var e = t(this);
            e.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
                e.removeClass("is-transitioning");
            });
            var i = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"],
                n = 0;
            t.each(i, function (t, i) {
                n || (n = parseFloat(e.css(i)));
            }),
                0 != n && (e.addClass("is-transitioning"), e[0].offsetWidth);
        });
    };
    var j = { passwordModal: ".password-modal", modalOpenButton: ".password__open-modal", modalCloseButton: ".password-modal__close", modalInput: ".password-modal__input" },
        U = { passwordModalOpen: "password-modal--open", disableScroll: "disable-scroll" };
    P.register("Password Template", "password-template", {
        onLoad: function (e) {
            var i = (this.$container = t(e));
            t(j.modalOpenButton, i).on("click", this.showPasswordModal.bind(this)), t(j.modalCloseButton, i).on("click", this.hidePasswordModal.bind(this)), t(".errors", i).length && this.showPasswordModal();
        },
        showPasswordModal: function () {
            var e = this.$container,
                i = t(j.passwordModal, e);
            q.trapFocus({ $container: i, namespace: "passwordModal", $elementToFocus: t(j.modalCloseButton, e) }),
                i.prepareTransition().addClass(U.passwordModalOpen),
                t(j.modalOpenButton, e).attr("aria-expanded", !0),
                t(j.modalInput, e).focus(),
                t(document.documentElement).addClass(U.disableScroll),
                t(document).on("keyup", this.closeOnEscape.bind(this));
        },
        hidePasswordModal: function () {
            var e = this.$container,
                i = t(j.passwordModal, e);
            q.removeTrapFocus({ namespace: "passwordModal" }),
                i.prepareTransition().removeClass(U.passwordModalOpen),
                t(document.documentElement).removeClass(U.disableScroll),
                t(j.modalOpenButton, e).attr("aria-expanded", !1).focus(),
                t(document).off("keyup", this.closeOnEscape.bind(this));
        },
        closeOnEscape: function (t) {
            27 === t.keyCode && this.hidePasswordModal();
        },
    }),
        t.extend(g.prototype, {
            registered: {},
            instances: [],
            extensions: { "*": [] },
            register: function (e, i) {
                function n(t) {
                    (this.type = e), v.call(this, t);
                }
                (n.constructor = this.registered[e]), (n.prototype = Object.create(v.prototype)), t.extend(n.prototype, i), (this.registered[e] = n);
            },
            load: function (t, e) {
                (t = this._normalizeTypeParam(t)),
                    (e = this._normalizeContainersParam(e)),
                    t.forEach(
                        function (t) {
                            var i = this.registered[t],
                                n = e;
                            void 0 !== i &&
                                (void 0 === n && (n = document.querySelectorAll('[data-section-type="' + t + '"]')),
                                (n = Array.prototype.slice.call(n)),
                                n.forEach(
                                    function (e) {
                                        if (!this._instanceExists(e)) {
                                            var n = this.extensions["*"].concat(this.extensions[t] || []),
                                                s = new i({ container: e, extensions: n, id: e.getAttribute("data-section-id") });
                                            s.trigger("section_load"), this.instances.push(s);
                                        }
                                    }.bind(this)
                                ));
                        }.bind(this)
                    );
            },
            extend: function (t, e) {
                (t = this._normalizeTypeParam(t)),
                    t.forEach(
                        function (t) {
                            (this.extensions[t] = this.extensions[t] || []),
                                this.extensions[t].push(e),
                                void 0 !== this.registered[t] &&
                                    this.instances.forEach(function (i) {
                                        i.type === t && i.extend(e);
                                    });
                        }.bind(this)
                    );
            },
            isInstance: function (t) {
                return "object" == typeof i(this.instances, { type: t });
            },
            getInstances: function (e) {
                return t.Deferred(
                    function (t) {
                        var i = a(this.instances, { type: e });
                        0 === i.length ? t.reject() : t.resolve(i);
                    }.bind(this)
                );
            },
            on: function () {
                var t = Array.prototype.slice.call(arguments);
                (t[0] = t[0].concat(this.namespace)), this.$document.on.apply(this.$document, t);
            },
            off: function () {
                var t = Array.prototype.slice.call(arguments);
                (t[0] = t[0].concat(this.namespace)), this.$document.off.apply(this.$document, arguments);
            },
            trigger: function () {
                var t = arguments;
                this.instances.forEach(function (e) {
                    e.trigger.apply(e, t);
                });
            },
            _sectionTrigger: function () {
                this.$document.trigger.apply(this.$document, arguments);
            },
            _normalizeTypeParam: function (t) {
                return (
                    "*" === t ? (t = Object.keys(this.registered)) : "string" == typeof t && (t = [t]),
                    (t = t.map(function (t) {
                        return t.toLowerCase();
                    }))
                );
            },
            _normalizeContainersParam: function (t) {
                return Array.isArray(t) || "object" != typeof t || (t = [t]), t;
            },
            _instanceExists: function (t) {
                return void 0 !== i(this.instances, { id: t.getAttribute("data-section-id") });
            },
        });
    var z = new g();
    (v.prototype = {
        onLoad: function () {},
        onUnload: function () {},
        onSelect: function () {},
        onDeselect: function () {},
        onBlockSelect: function () {},
        onBlockDeselect: function () {},
        on: function () {
            var t = Array.prototype.slice.call(arguments);
            (t[0] = t[0].concat(this.namespace)), this.$eventBinder.on.apply(this.$eventBinder, t), (this.$eventBinder = this.$container);
        },
        one: function () {
            var t = Array.prototype.slice.call(arguments);
            (t[0] = t[0].concat(this.namespace)), this.$eventBinder.one.apply(this.$eventBinder, t), (this.$eventBinder = this.$container);
        },
        off: function () {
            var t = Array.prototype.slice.call(arguments);
            (t[0] = t[0] || ""), (t[0] = t[0].concat(this.namespace)), this.$eventBinder.off.apply(this.$eventBinder, arguments), (this.$eventBinder = this.$container);
        },
        trigger: function () {
            var t = Array.prototype.slice.call(arguments);
            (t[1] = t[1] || []), t[1].splice(0, 0, this), this.$eventBinder.trigger.apply(this.$eventBinder, t), (this.$eventBinder = this.$container);
        },
        extend: function (i) {
            var n = i.init;
            this.extensions.push(i), t.extend(this, e(i, "init")), t.isFunction(n) && n.apply(this);
        },
    }),
        (v.prototype.document = function () {
            var e = t(document),
                i = this;
            return {
                on: function () {
                    (i.$eventBinder = e), i.on.apply(i, arguments);
                },
                off: function () {
                    (i.$eventBinder = e), i.off.apply(i, arguments);
                },
                trigger: function () {
                    (i.$eventBinder = e), i.trigger.apply(i, arguments);
                },
            };
        }),
        (v.prototype.window = function () {
            var e = t(window),
                i = this;
            return {
                on: function () {
                    (i.$eventBinder = e), i.on.apply(i, arguments);
                },
                off: function () {
                    (i.$eventBinder = e), i.off.apply(i, arguments);
                },
                trigger: function () {
                    (i.$eventBinder = e), i.trigger.apply(i, arguments);
                },
            };
        });
    var Q = { cardListSubLoaded: "card-list__sub-actions--loaded", cardReveal: "card--reveal", searchTemplate: "template-search" },
        K = { cardList: ".card-list", cardListColumn: ".card-list__column", cardListSub: ".card-list__sub-actions", card: ".card", cardWrapper: ".card__wrapper", cardInfo: ".card__info" },
        X = {
            init: function () {
                (this.$cardList = t(K.cardList, this.$container)),
                    (this.$emptyColumn = t(K.cardListColumn, this.$container).clone().empty()),
                    (this.$cards = t(K.card, this.$container)),
                    (this.desktopColumnCount = this.$cardList.data("desktop-columns") || 2),
                    (this.mobileColumnCount = this.$cardList.data("mobile-columns") || 1),
                    (this.columnCount = B.isMobile() ? this.mobileColumnCount : this.desktopColumnCount),
                    (this.gridStyle = this.$cardList.data("grid-style") || "collage"),
                    (this.windowWidth = t(window).outerWidth()),
                    (this.cardLoadPromises = []),
                    this.window().on("resize", this._onResize.bind(this)),
                    this.on("keydown", K.cardWrapper, this._onCardTabDown.bind(this)),
                    this.on("keyup", this._onCardTabUp.bind(this)),
                    B.promiseStylesheet().then(
                        function () {
                            (this.cardsLoaded = this._loadCards()), t("html").removeClass("site-footer--hidden"), t(K.cardListSub, this.$container).prepareTransition().addClass(Q.cardListSubLoaded);
                        }.bind(this)
                    );
            },
            _onResize: function () {
                var e = B.isMobile() ? this.mobileColumnCount : this.desktopColumnCount;
                this.columnCount !== e && ((this.columnCount = e), (this.$columns = this._replaceColumns())),
                    t.each(
                        this.$cards,
                        function (t) {
                            if (B.isMobile()) this.$columns.find(K.cardWrapper).removeAttr("style");
                            else if (this._isAlignedRow(t + 1)) {
                                var e = (t - (t % this.desktopColumnCount)) / this.desktopColumnCount + 1;
                                this._matchRowHeights(this.$columns, e);
                            }
                        }.bind(this)
                    );
            },
            _onCardTabDown: function (e) {
                if (9 === e.keyCode) {
                    var i = t(e.target).data("tabindex");
                    (this.tabFromList = !0),
                        e.shiftKey
                            ? i > 1 && (e.preventDefault(), t("[data-tabindex=" + (i - 1) + "]").focus())
                            : i === this.$cards.length
                            ? t(K.cardWrapper, this.$container).last().focus()
                            : (e.preventDefault(), t("[data-tabindex=" + (i + 1) + "]").focus());
                }
            },
            _onCardTabUp: function (e) {
                if (9 === e.keyCode) {
                    var i = this.tabFromList || !1;
                    (this.tabFromList = !1), e.shiftKey && !i && t(K.cardWrapper, this.$container).last().is(e.target) && t("[data-tabindex=" + this.$cards.length + "]").focus();
                }
            },
            _loadCards: function () {
                return (
                    this.trigger("cards_load_start"),
                    (this.$columns = this._addColumns()),
                    this._promiseAllCardsReveal().always(
                        function () {
                            this.trigger("cards_load_done");
                        }.bind(this)
                    )
                );
            },
            _addColumns: function () {
                for (var e, i = 1; i < this.columnCount; i++) this.$cardList.append(this.$emptyColumn.clone());
                return (e = t(K.cardListColumn, this.$container)), (e.heights = r(Array(this.columnCount), 0)), (e.lengths = r(Array(this.columnCount), 0)), e;
            },
            _replaceColumns: function () {
                var e = this.$emptyColumn.clone();
                (e.heights = r(Array(this.columnCount), 0)), (e.lengths = r(Array(this.columnCount), 0));
                for (var i = 1; i < this.columnCount; i++) e.push(this.$emptyColumn.clone()[0]);
                return (
                    t.each(
                        this.$cards,
                        function (i, n) {
                            this._positionCard(t(n), i, e);
                        }.bind(this)
                    ),
                    this.$cardList.html(e),
                    e
                );
            },
            _promiseAllCardsReveal: function () {
                var e = t.Deferred().resolve();
                return (
                    this.$cards.each(
                        function (i, n) {
                            if ((this._positionCard(t(n), i, this.$columns), !B.isMobile() && this._isAlignedRow(i + 1))) {
                                var s = this.$columns.lengths[0];
                                this._matchRowHeights(this.$columns, s);
                            }
                            var o = this._promiseRevealReady(n);
                            e = e
                                .then(function () {
                                    return o;
                                })
                                .then(this._revealCard.bind(this, n))
                                .then(function () {
                                    return t.Deferred(function (t) {
                                        setTimeout(t.resolve, 80);
                                    });
                                });
                        }.bind(this)
                    ),
                    e
                );
            },
            _revealCard: function (e) {
                var i = t(e);
                this.trigger("card_loaded", [i[0]]), requestAnimationFrame(i.addClass.bind(i, Q.cardReveal));
            },
            _promiseRevealReady: function (e) {
                return t.Deferred(function (i) {
                    function n(t, o) {
                        o === e && (s.off("animate_element", n), i.resolve());
                    }
                    var s = t(e);
                    t("html").hasClass("is-ios") && Shopify.designMode
                        ? (t(e).addClass(Q.cardReveal), i.resolve())
                        : (requestAnimationFrame(function () {
                              if (B.isInOrAboveViewport(e)) return i.resolve();
                          }),
                          s.on("animate_element", n));
                });
            },
            _positionCard: function (t, e, i) {
                var n = 0,
                    s = t.outerHeight(!0);
                if ("collage" === this.gridStyle) {
                    n = i.heights.indexOf(Math.min.apply(Math, i.heights));
                    for (var o = 0; o < i.heights.length; o++)
                        if (i.heights[n] > i.heights[o] - 150) {
                            n = o;
                            break;
                        }
                } else n = i.lengths.indexOf(Math.min.apply(Math, i.lengths));
                i.eq(n).append(t), 0 !== t.outerHeight() || B.isMobile() || t.find(K.cardWrapper).outerHeight(s), "collage" === this.gridStyle && (i.heights[n] += s), i.lengths[n]++, t.find("a").attr("data-tabindex", e + 1);
            },
            _matchRowHeights: function (e, i) {
                for (var n = 0, s = 0, o = "", a = !1, r = 0; r < e.length; r++) (o += "[data-tabindex='" + ((i - 1) * e.length + r + 1) + "']"), r < e.length - 1 && (o += ", ");
                for (var d = e.find(o).parent(), l = 0; l < d.length; l++)
                    (a = t(d[l]).find(K.cardWrapper).is(".card--article")),
                        (s = t(d[l]).find(K.cardWrapper).outerWidth()),
                        (s = t(document.body).hasClass(Q.searchTemplate) && a ? t(d[l]).find(K.cardWrapper).outerHeight() : t(d[l]).find(K.cardWrapper).outerWidth() + t(d[l]).find(K.cardInfo).outerHeight()) > n && (n = s);
                d.find(K.cardWrapper).outerHeight(n);
            },
            _isAlignedRow: function (t) {
                return "grid" === this.gridStyle && (t % this.desktopColumnCount == 0 || t === this.$cards.length);
            },
        };
    z.register("blog-template", {
        onLoad: function () {
            this.extend(X);
        },
    });
    var Y = {
            isUpdating: !1,
            getCart: function () {
                return t.getJSON("/cart.js");
            },
            on: function (e, i) {
                t(this).on(e, i);
            },
            trigger: function (e, i) {
                t(this).triggerHandler(e, i);
            },
            updateNote: function (t) {
                return this._promiseChange({ url: "/cart/update.js", dataType: "json", data: { note: t || "" } });
            },
            addItem: function (t, e) {
                return this._promiseChange({ url: "/cart/add.js", dataType: "json", data: { id: t, quantity: void 0 === e ? 1 : e } });
            },
            addItemFromForm: function (t) {
                return this._promiseChange({ url: "/cart/add.js", dataType: "json", processData: !1, contentType: !1, type: "POST", data: t });
            },
            removeItem: function (t) {
                return this._promiseChange({ url: "/cart/change.js", dataType: "json", data: { id: t, quantity: 0 } });
            },
            changeItem: function (t, e) {
                return this._promiseChange({ url: "/cart/change.js", dataType: "json", data: { id: t, quantity: e } });
            },
            saveLocalState: function (t) {
                return B.isLocalStorageSupported() && (localStorage.shopify_cart_state = JSON.stringify(t)), t;
            },
            getLocalState: function () {
                if (B.isLocalStorageSupported()) return JSON.parse(localStorage.shopify_cart_state || "");
            },
            _promiseChange: function (e) {
                var i = t.ajax(e);
                return (
                    (this.isUpdating = !0),
                    navigator && !theme.isOnline && (i = t.Deferred().reject()),
                    i
                        .then(
                            function (t) {
                                return void 0 === t.token ? this.getCart() : t;
                            }.bind(this)
                        )
                        .then(this.saveLocalState)
                        .then(this._triggerChangeEvent.bind(this))
                        .catch(this._triggerErrorEvent.bind(this))
                        .always(
                            function () {
                                this.isUpdating = !1;
                            }.bind(this)
                        )
                );
            },
            _triggerChangeEvent: function (t) {
                return this.trigger("change", t), t;
            },
            _triggerErrorEvent: function (t) {
                throw (this.trigger("error", t), t);
            },
        },
        G = {
            formatMoney: function (t, e) {
                function i(t, e, i, n) {
                    if (((e = h(e, 2)), (i = h(i, ",")), (n = h(n, ".")), isNaN(t) || null === t)) return 0;
                    t = (t / 100).toFixed(e);
                    var s = t.split(".");
                    return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (s[1] ? n + s[1] : "");
                }
                "string" == typeof t && (t = t.replace(".", ""));
                var n = "",
                    s = /\{\{\s*(\w+)\s*\}\}/,
                    o = e || "${{amount}}";
                switch (o.match(s)[1]) {
                    case "amount":
                        n = i(t, 2);
                        break;
                    case "amount_no_decimals":
                        n = i(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        n = i(t, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        n = i(t, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        n = i(t, 0, " ");
                        break;
                    case "amount_with_apostrophe_separator":
                        n = i(t, 2, "'");
                }
                return o.replace(s, n);
            },
        },
        J = {
            preload: function (t, e) {
                "string" == typeof t && (t = [t]);
                for (var i = 0; i < t.length; i++) {
                    var n = t[i];
                    this.loadImage(this.getSizedImageUrl(n, e));
                }
            },
            loadImage: function (t) {
                new Image().src = t;
            },
            switchImage: function (t, e, i) {
                var n = this.imageSize(e.src),
                    s = this.getSizedImageUrl(t.src, n);
                i ? i(s, t, e) : (e.src = s);
            },
            imageSize: function (t) {
                t = t || "";
                var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
                return null !== e ? e[1] : null;
            },
            getSizedImageUrl: function (t, e) {
                if (null === e) return t;
                if ("master" === e) return this.removeProtocol(t);
                var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null !== i) {
                    var n = t.split(i[0]),
                        s = i[0];
                    return this.removeProtocol(n[0] + "_" + e + s);
                }
                return null;
            },
            removeProtocol: function (t) {
                return t.replace(/http(s)?:/, "");
            },
        },
        Z = { itemId: "data-cart-item-id" },
        tt = {
            ajaxCart: ".cart-drawer",
            itemList: "[data-cart-item-list]",
            item: "[data-cart-item]",
            itemId: "[data-cart-item-id]",
            itemHref: "[data-cart-item-href]",
            itemImage: "[data-cart-item-image]",
            itemBackgroundImage: "[data-cart-item-background-image]",
            itemTitle: "[data-cart-item-title]",
            itemVariantTitle: "[data-cart-item-variant-title]",
            itemPropertyList: "[data-cart-item-property-list]",
            itemProperty: "[data-cart-item-property]",
            itemDiscountList: "[data-cart-item-discount-list]",
            itemDiscount: "[data-cart-item-discount]",
            itemDiscountTitle: "[data-cart-item-discount-title]",
            itemDiscountAmount: "[data-cart-item-discount-amount]",
            itemLabelQuantity: "[data-cart-item-label-quantity]",
            itemInputQuantity: "[data-cart-item-input-quantity]",
            itemDelete: "[data-cart-item-delete]",
            itemPriceContainer: "[data-cart-item-price-container]",
            itemLinePriceContainer: "[data-cart-item-line-price-container]",
            itemMessage: "[data-item-message]",
            cartDiscountContainer: "[data-cart-discount-container]",
            cartDiscount: "[data-cart-discount]",
            cartDiscountTitle: "[data-cart-discount-title]",
            cartDiscountAmount: "[data-cart-discount-amount]",
            cartNoteContainer: "[data-cart-note-container]",
            cartNoteInput: "[data-cart-note]",
            cartMessage: "[data-cart-message]",
            cartSubtotal: "[data-cart-subtotal]",
            cartSubmit: "[data-cart-submit]",
        },
        et = {
            cartTemplate: "ajax-cart__template",
            cartItemRemove: "ajax-cart__item--remove",
            cartError: "ajax-cart--error",
            visuallyHidden: "visually-hidden",
            cartDiscountActive: "ajax-cart__discount-container--active",
            btnLoaderActive: "btn--loader-active",
        },
        it = {
            init: function () {
                (this.$ajaxCart = t(tt.ajaxCart, this.$container)),
                    (this.$itemTemplate = t(tt.item, this.$container).first().clone()),
                    (this.$propertyTemplate = t(tt.itemProperty, this.$container).first().clone()),
                    (this.$discountTemplate = t(tt.itemDiscount, this.$container).first().clone()),
                    (this.$cartDiscountTemplate = t(tt.cartDiscount, this.$container).first().clone()),
                    Y.on("quantity", this._onQuantityError.bind(this)),
                    Y.on(
                        "change",
                        function (t, e) {
                            this.update(e);
                        }.bind(this)
                    ),
                    this.on("input", tt.itemInputQuantity, d(this._onItemQuantityChange.bind(this), 500)),
                    this.on("blur", tt.itemInputQuantity, this._onItemQuantityEmptyBlur.bind(this)),
                    this.on("focus", tt.itemInputQuantity, this._highlightText),
                    this.on("click", tt.itemDelete, this._onItemDelete.bind(this)),
                    this.on("change", tt.cartNoteInput, this._onNoteChange.bind(this)),
                    this.on("submit", this._onSubmit.bind(this)),
                    this.window().on("storage", this._onStorageStateChange.bind(this));
            },
            refresh: function () {
                Y.getCart().then(this.update.bind(this));
            },
            update: function (t) {
                this.trigger("cart_update_start", [t]);
                var e = this._createCart(t);
                l(this.$container[0], e[0]), this.trigger("cart_update_done", [t]);
            },
            _onError: function (e) {
                this.trigger("cart_error", [e]), this.$container.addClass(et.cartError), t(tt.item, this.$container).removeClass(et.cartItemRemove), t(tt.cartMessage, this.$container).text(theme.strings.cartError);
            },
            _onQuantityError: function (e, i) {
                this.trigger("cart_item_quantity_error", [i]), this.$container.addClass(et.cartError);
                var n = theme.strings.cartQuantityError.replace("[quantity]", i.quantity).replace("[title]", i.title),
                    s = t(tt.itemMessage, t("[" + Z.itemId + '="' + i.key + '"]'));
                s.removeAttr("aria-hidden"), s.html(n);
            },
            _createCart: function (e) {
                var i = this.$container.clone();
                return (
                    i.removeClass(et.cartError),
                    t(tt.cartMessage, i).text(""),
                    t(tt.item, i).not(tt.cartNoteContainer).remove(),
                    t(tt.itemList, i).prepend(this._createItemList(e)),
                    t(tt.cartNoteInput, i).val(e.note),
                    t(tt.cartDiscountContainer, i).toggleClass(et.cartDiscountActive, 0 !== e.total_discount),
                    t(tt.cartDiscountContainer, i).html(this._createCartDiscountList(e)),
                    t(tt.cartSubtotal, i).html(G.formatMoney(e.total_price, theme.moneyFormat)),
                    t(tt.cartSubmit, i).attr("disabled", 0 === e.items.length),
                    i
                );
            },
            _createItemList: function (e) {
                return t.map(
                    e.items,
                    function (e) {
                        var i = this.$itemTemplate.clone().removeClass(et.cartTemplate),
                            n = this._createPropertyList(e),
                            s = this._createDiscountList(e),
                            o = this._createItemPrice(e),
                            a = this._createItemTotalPrice(e);
                        return (
                            i.find(tt.itemId).addBack(tt.itemId).attr(Z.itemId, e.key),
                            t(tt.itemHref, i).attr("href", e.url),
                            t(tt.itemImage, i)
                                .attr("src", e.image ? J.getSizedImageUrl(e.image, "medium") : "")
                                .toggleClass("hide", "string" != typeof e.image),
                            t(tt.itemBackgroundImage, i).css("background-image", e.image ? "url(" + J.getSizedImageUrl(e.image, "medium") + ")" : "none"),
                            t(tt.itemTitle, i).text(e.product_title),
                            t(tt.itemVariantTitle, i).text(e.variant_title),
                            t(tt.itemPriceContainer, i).html(o),
                            t(tt.itemLinePriceContainer, i).html(a),
                            t(tt.itemLabelQuantity, i).attr("for", "quantity_" + e.key),
                            t(tt.itemInputQuantity, i)
                                .attr("name", "updates[" + e.key + "]")
                                .attr("id", "quantity_" + e.key)
                                .val(e.quantity),
                            t(tt.itemPropertyList, i).html(n),
                            t(tt.itemDiscountList, i).html(s),
                            i[0]
                        );
                    }.bind(this)
                );
            },
            _createItemPrice: function (t) {
                var e = "";
                return (e += this._createItemProductPrice(t.original_price, t.final_price)), t.unit_price_measurement && (e += this._createItemUnitPrice(t)), e;
            },
            _createItemTotalPrice: function (t) {
                var e = "";
                return (e += this._createItemProductPrice(t.original_line_price, t.final_line_price));
            },
            _createItemProductPrice: function (t, e) {
                var i = "";
                return (i +=
                    t !== e
                        ? '<span class="visually-hidden">' +
                          theme.strings.regularPrice +
                          '</span><del class="cart-item__original-price">' +
                          G.formatMoney(t, theme.moneyFormat) +
                          '</del><span class="visually-hidden">' +
                          theme.strings.salePrice +
                          '</span><span class="order-discount cart-item__price">' +
                          G.formatMoney(e, theme.moneyFormat) +
                          "</span>"
                        : '<span class="cart-item__original-price cart-item__price">' + G.formatMoney(t, theme.moneyFormat) + "</span>");
            },
            _createItemUnitPrice: function (t) {
                return (
                    '<span class="product-price-unit"><span class="visually-hidden">' +
                    theme.strings.unitPrice +
                    "</span><span>" +
                    G.formatMoney(t.unit_price, theme.moneyFormat) +
                    '</span><span aria-hidden="true">/</span><span class="visually-hidden">&nbsp;' +
                    theme.strings.unitPriceSeparator +
                    "&nbsp;</span><span>" +
                    (1 !== t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_value : "") +
                    t.unit_price_measurement.reference_unit +
                    "</span></span>"
                );
            },
            _createPropertyList: function (e) {
                return t.map(
                    e.properties,
                    function (t, e) {
                        var i = this.$propertyTemplate.clone().removeClass(et.cartTemplate);
                        if ("_" !== e.charAt(0) && "" !== t) return -1 === t.indexOf("/uploads/") ? i.text(e + ": " + t) : i.html(e + ': <a href="' + t + '">' + t.split("/").pop() + "</a>"), i[0];
                    }.bind(this)
                );
            },
            _createDiscountList: function (e) {
                return t.map(
                    e.line_level_discount_allocations,
                    function (t) {
                        var e = this.$discountTemplate.clone().removeClass(et.cartTemplate);
                        return e.find(tt.itemDiscountTitle).text(t.discount_application.title), e.find(tt.itemDiscountAmount).html(G.formatMoney(t.amount, theme.moneyFormat)), e[0];
                    }.bind(this)
                );
            },
            _createCartDiscountList: function (e) {
                return t.map(
                    e.cart_level_discount_applications,
                    function (t) {
                        var e = this.$cartDiscountTemplate.clone().removeClass(et.cartTemplate);
                        return e.find(tt.cartDiscountTitle).text(t.title), e.find(tt.cartDiscountAmount).html(G.formatMoney(t.total_allocated_amount, theme.moneyFormat)), e[0];
                    }.bind(this)
                );
            },
            _onStorageStateChange: function (t) {
                if ("shopify_cart_state" === t.key) {
                    var e = Y.getLocalState();
                    this.trigger("cart_storage_state_change", [e]), this.update(Y.getLocalState());
                }
            },
            _onItemQuantityChange: function (e) {
                var i = t(e.target),
                    n = i.closest(tt.item).attr(Z.itemId),
                    s = i.val();
                "" !== s && (this.trigger("cart_item_quantity_change", [n, s]), Y.changeItem(n, s).catch(this._onError.bind(this)));
            },
            _onItemQuantityEmptyBlur: function (e) {
                "" === t(e.target).val() && this.refresh();
            },
            _onItemDelete: function (e) {
                e.preventDefault();
                var i = t(e.target),
                    n = t(tt.item, this.$container),
                    s = i.closest(tt.item),
                    o = t(tt.cartNoteContainer, this.$container),
                    a = s.attr(Z.itemId);
                this.trigger("cart_item_remove", [a]),
                    2 === n.length &&
                        n.last().is(o) &&
                        (o.addClass(et.cartItemRemove),
                        B.promiseTransitionEnd(t(tt.itemList, this.$container)).then(function () {
                            o.removeClass(et.cartItemRemove);
                        })),
                    s.addClass(et.cartItemRemove),
                    B.promiseAnimationEnd(s).then(
                        function () {
                            Y.removeItem(a).catch(this._onError.bind(this));
                        }.bind(this)
                    );
            },
            _onNoteChange: function (e) {
                var i = t(e.target).val();
                this.trigger("cart_note_change", [i]), Y.updateNote(i).catch(this._onError.bind(this));
            },
            _onSubmit: function (e) {
                Y.isUpdating ? e.preventDefault() : (t(tt.cartSubmit, this.$container).addClass(et.btnLoaderActive), this.trigger("cart_submit"));
            },
            _highlightText: function (e) {
                t(e.target).select();
            },
        },
        nt = { drawerActive: "drawer--active", disableScroll: "disable-scroll" },
        st = { drawerPush: "[data-drawer-push]", drawerCover: ".drawer-cover", mainContent: ".main-content", siteHeader: ".site-header" },
        ot = {
            init: function () {
                (this.$toggleButton = null), (this.draggingAction = null), (this.namespaceTouch = ".onTouchStart"), (this.namespaceOpen = ".onOpen"), this.document().on("resize", this._onWindowResize.bind(this));
            },
            drawerOpen: function (e) {
                this.trigger("drawer_open_start"),
                    q.trapFocus({ $container: this.$container, namespace: "drawer" }),
                    e && e.currentTarget && (this.$toggleButton = t(e.target).attr("aria-expanded", !0)),
                    B.disableScrollBody(),
                    t("body").addClass(nt.drawerActive),
                    this.trigger("drawer_open_transitioning"),
                    B.promiseTransitionEnd(this.$container).then(
                        function () {
                            B.enableTabbingOfChildren(this.$container),
                                this.$container.attr("aria-hidden", !1),
                                this.document().on("click touchend" + this.namespaceOpen, st.drawerCover, this.drawerClose.bind(this)),
                                this.document().on("keyup" + this.namespaceOpen, this._closeOnEscape.bind(this)),
                                this.document().on("touchstart" + this.namespaceOpen, this._onTouchStart.bind(this)),
                                this.trigger("drawer_open_done");
                        }.bind(this)
                    );
            },
            drawerClose: function () {
                this.trigger("drawer_close_start"),
                    q.removeTrapFocus({ namespace: "drawer" }),
                    this.$toggleButton && this.$toggleButton.length && (this.$toggleButton.focus().attr("aria-expanded", !1), (this.$toggleButton = null)),
                    B.enableScrollBody(),
                    B.disableTabbingOfChildren(this.$container),
                    this.$container.attr("aria-hidden", !0),
                    this.document().off(this.namespaceOpen),
                    t("body").removeClass(nt.drawerActive),
                    this.trigger("drawer_close_transitioning"),
                    B.promiseTransitionEnd(this.$container).then(
                        function () {
                            this.trigger("drawer_close_done");
                        }.bind(this)
                    );
            },
            _onWindowResize: function () {
                this.sliderWidth = 0;
            },
            _onTouchStart: function (e) {
                (this.startPosition = B.pointerEventToXY(e)),
                    (this.$elementsToPush = this.$elementsToPush || t(st.drawerPush)),
                    (this.sliderWidth = this.sliderWidth || this.$container.width()),
                    (this.isDragging = !1),
                    this.document().on("touchmove" + this.namespaceTouch, this._onTouchMove.bind(this)),
                    this.document().on("touchend" + this.namespaceTouch, this._onTouchEnd.bind(this));
            },
            _onTouchMove: function (t) {
                var e, i, n, s;
                (this.isDragging = !0),
                    (this.currentPosition = B.pointerEventToXY(t)),
                    this.trigger("drawer_dragging", [this.currentPosition]),
                    (e = this.currentPosition.x - this.startPosition.x),
                    (i = this.currentPosition.y - this.startPosition.y),
                    (n = Math.atan2(e, i) / (Math.PI / 180)),
                    (this.translated = e > 0 ? e : 0),
                    Math.abs(n) > 65 && Math.abs(n) < 115 && null === this.draggingAction ? (this.draggingAction = "slide") : (Math.abs(n) < 65 || Math.abs(n) > 115) && null === this.draggingAction && (this.draggingAction = "scroll"),
                    "slide" === this.draggingAction && (t.preventDefault(), (s = { transform: "translateX(-" + (this.sliderWidth - this.translated) + "px)", transition: "none" }), this.$elementsToPush.css(s));
            },
            _onTouchEnd: function () {
                var t;
                (this.wasDragging = this.isDragging),
                    (this.isDragging = !1),
                    this.wasDragging &&
                        ((t = this.translated / this.sliderWidth),
                        t > 0.25 && "slide" === this.draggingAction ? (this.drawerClose("ease-out"), this.trigger("drawer_dragging_success")) : this.trigger("drawer_dragging_fail"),
                        this.$elementsToPush.removeAttr("style")),
                    (this.draggingAction = null),
                    this.document().off(this.namespaceTouch);
            },
            _closeOnEscape: function (t) {
                27 === t.keyCode && this.drawerClose();
            },
        },
        at = {
            drawer: ".drawer",
            cartHeader: ".cart-drawer__header",
            cartTitle: ".cart-drawer__header-title",
            cartContent: ".cart-drawer__content",
            cartToggle: ".ajax-cart__toggle",
            cartCloseButton: ".cart-drawer__close-button",
            siteHeader: ".site-header",
        },
        rt = { cartTemplate: "template-cart", cartEmpty: "cart-drawer--empty", cartNoCookies: "cart-drawer--no-cookies" };
    z.register("cart-drawer", {
        onLoad: function () {
            if (!t(document.body).hasClass(rt.cartTemplate)) {
                if ((this.extend(ot), this._setDrawerHeaderHeight(), this.on("drawer_close_done", this._onDrawerClose.bind(this)), this.document().on("click", at.cartToggle, this._openCartDrawer.bind(this)), !B.cookiesEnabled()))
                    return void this.$container.addClass(rt.cartNoCookies);
                this.extend(it),
                    Y.on(
                        "change",
                        function (t, e) {
                            this.$ajaxCart.toggleClass(rt.cartEmpty, 0 === e.items.length);
                        }.bind(this)
                    );
            }
        },
        onSelect: function () {
            this._openCartDrawer();
        },
        onDeselect: function () {
            this._closeCartDrawer();
        },
        _onDrawerClose: function () {
            z.getInstances("header-section").then(function (t) {
                t[0].scrollHandler = !0;
            });
        },
        _setDrawerHeaderHeight: function () {
            var e = t(at.cartHeader, this.$container),
                i = t(at.siteHeader).outerHeight();
            e.css("height", i);
        },
        _openCartDrawer: function (e) {
            e.preventDefault(),
                z
                    .getInstances("header-section")
                    .then(function (t) {
                        return (t[0].scrollHandler = !1), t[0].hideNavigation();
                    })
                    .then(
                        function () {
                            this.drawerOpen(e), t(at.cartContent, this.$container).scrollTop(0), q.forceFocus(t(at.cartTitle, this.$container)), this.$container.on("click", at.cartCloseButton, this._closeCartDrawer.bind(this));
                        }.bind(this)
                    );
        },
        _closeCartDrawer: function () {
            this.drawerClose();
        },
    });
    var dt = { showClass: "cart-item__update--show", showEditClass: "cart-item__edit--active", cartEmpty: "cart--empty", cartNoCookies: "cart--no-cookies" };
    z.register("cart-template", {
        onLoad: function () {
            var e = t(this.container);
            if (!B.cookiesEnabled()) return void e.addClass(dt.cartNoCookies);
            this.extend(it),
                Y.on("change", function (t, i) {
                    e.toggleClass(dt.cartEmpty, 0 === i.items.length);
                });
        },
    });
    var lt = { filterBy: "#FilterBy", sortBy: "#SortBy", collectionImage: ".section-header-image" },
        ht = {};
    z.register("collection-template", {
        onLoad: function () {
            var e = (this.$container = t(this.container)),
                i = t(lt.filterBy, e),
                n = t(lt.sortBy, e);
            (this.defaultSort = this.getDefaultSortValue()), this.extend(X), this.initParams(), i.on("change", this.onFilterChange.bind(this)), n.on("change", this.onSortChange.bind(this));
        },
        initParams: function () {
            if (location.search.length) for (var t, e = location.search.substr(1).split("&"), i = 0; i < e.length; i++) (t = e[i].split("=")), t.length > 1 && (ht[decodeURIComponent(t[0])] = decodeURIComponent(t[1]));
        },
        onSortChange: function () {
            (ht.sort_by = this.getSortValue()), ht.page && delete ht.page, (location.search = decodeURIComponent(t.param(ht)));
        },
        onFilterChange: function () {
            (this.filter = this.getFilterValue()), (document.location.href = this.filter);
        },
        getSortValue: function () {
            return t(lt.sortBy).val() || this.defaultSort;
        },
        getDefaultSortValue: function () {
            return t(lt.sortBy, this.$container).val() || "title-ascending";
        },
        getFilterValue: function () {
            return t(lt.filterBy, this.$container).val() || "collections/all";
        },
    }),
        z.register("featured-blog", {
            onLoad: function () {
                this.extend(X);
            },
        });
    var ct,
        ut = {
            validate: function (e) {
                if ("object" != typeof e || "number" != typeof e.id) throw Error("Please pass a valid Product object to the Product Controller");
                return t.extend({}, e);
            },
            getVariant: function (t, e) {
                var i;
                return (
                    "string" == typeof e || "number" == typeof e
                        ? (i = this._getVariantFromId(t, e))
                        : "object" == typeof e && "number" == typeof e.id
                        ? (i = this._getVariantFromId(t, e.id))
                        : u(e) && (i = "object" == typeof e[0] ? this._getVariantFromOptionCollection(t, e) : this._getVariantFromOptionArray(t, e)),
                    i
                );
            },
            optionArrayFromOptionCollection: function (t, e) {
                var i = [];
                return (
                    e.forEach(function (e) {
                        var n;
                        if ("string" != typeof e.name) throw Error("Invalid value type passed for name of option " + n + ". Value should be string.");
                        if (
                            -1 ===
                            (n = c(t.options, function (t) {
                                return t.toLowerCase() === e.name.toLowerCase();
                            }))
                        )
                            throw Error("Invalid option name, " + e.name);
                        i[n] = e.value;
                    }),
                    i
                );
            },
            _getVariantFromId: function (t, e) {
                return i(t.variants, { id: e });
            },
            _getVariantFromOptionCollection: function (t, e, i) {
                var n = this.optionArrayFromOptionCollection(t, e);
                return this._getVariantFromOptionArray(t, n, i);
            },
            _getVariantFromOptionArray: function (t, e) {
                return i(t.variants, function (t) {
                    return e.every(function (e, i) {
                        return t.options[i] === e;
                    });
                });
            },
        },
        pt = {
            productPriceSale: "product__price--sale",
            productPriceUnitUnavailable: "product-price-unit--unavailable",
            productNotificationSuccess: "product__notification--success",
            productNotificationError: "product__notification--error",
            buttonTransition: "btn--to-secondary-transitioned",
            ajaxCartToggle: "ajax-cart__toggle",
            hide: "hide",
            lazyPreload: "lazypreload",
        },
        mt = {
            productForm: ".product-form",
            selectorWrapper: ".product-form__item",
            ajaxCartToggle: ".ajax-cart__toggle",
            shopifyPaymentButton: ".shopify-payment-button",
            productJSON: "[data-product-json]",
            optionInputs: "[data-option-input]",
            masterSelect: "[data-master-select]",
            variantMediaImage: "[data-variant-media-image]",
            variantMediaToggleHide: "[data-variant-media-toggle-hide]",
            productPrice: "[data-product-price]",
            regularPrice: "[data-regular-price]",
            compareAtPrice: "[data-compare-price]",
            unitPrice: "[data-unit-price]",
            unitPriceBaseUnit: "[data-unit-price-base-unit]",
            unitPriceContainer: "[data-unit-price-container]",
            submitButton: "[data-cart-submit]",
            submitButtonPrimaryText: "[data-cart-primary-submit-text]",
            submitButtonSecondaryText: "[data-cart-secondary-submit-text]",
            notification: "[data-cart-notification]",
            shopifyXr: "[data-shopify-xr]",
        },
        ft = {
            init: function () {
                var e = t(mt.productJSON, this.container);
                0 !== e.length &&
                    ((this.product = JSON.parse(e.html())),
                    (this.variant = ut.getVariant(this.product, this.$container.data("variant-id"))),
                    this._formatVariantSelectors(),
                    this.on("submit", mt.productForm, this._addItemToCart.bind(this)),
                    this.one("focus", mt.optionInputs, this._preloadVariantMediaImages.bind(this)),
                    this.on("change.variantController", mt.optionInputs, this.update.bind(this)),
                    this.document().on("click", mt.ajaxCartToggle, this._resetAddToCartButton.bind(this)),
                    this.window().on("online", this._updateOnlineStatus),
                    this.window().on("offline", this._updateOfflineStatus));
            },
            update: function () {
                var e = t(mt.optionInputs, this.$container),
                    i = e.serializeArray(),
                    n = ut.getVariant(this.product, i);
                void 0 === n
                    ? (this.trigger("variant_change_undefined", [this.product, i]), (n = t.extend({}, this.variant)), (n.isUndefined = !0), (n.available = !1), (n.options = ut.optionArrayFromOptionCollection(this.product, i)))
                    : this.trigger("variant_change_successful", [this.product, n]),
                    (this.variant = n),
                    l(this.$container[0], this._updatedContainer(this.variant)),
                    this.trigger("variant_change", [this.product, n]);
              
              /**/
              // Update variant description
              var VTitle = this.variant.title;
              var VTitles = VTitle.toLowerCase().replace(/ /g,'-').replace('/', '');
              //console.log(VTitles);
              t('.variant-selected').removeClass('show').addClass('hide');
              t('.variant-selected.variant-' + VTitles).removeClass('hide').addClass('show');
              
              
              var VId = this.variant.id;
              var num = t('#target-' + VId).data('number');
              var lastnum = t('.gallery-top .swiper-slide:last-child').data('number');
              var maxnum = t('.gallery-top').width() * lastnum;
              //var transform = t(window).width() * num;
              var transform = t('.gallery-top').width() * num;
              
              var height = t('#target-' + VId).height();
              var nthPrev = num;
              var nthNext = num + 2;
              var navActive = num + 1;
              console.log(VId + '&' + nthPrev + '&' + nthNext);
              t('.swiper-slide').removeClass('swiper-slide-thumb-active').removeClass('swiper-slide-prev').removeClass('swiper-slide-next');
              t('.swiper-wrapper .swiper-slide:nth-child(' + nthPrev + ')').addClass('swiper-slide-prev');
              t('.swiper-wrapper .swiper-slide:nth-child(' + nthNext + ')').addClass('swiper-slide-next');
              t('#target-' + VId).addClass('swiper-slide-thumb-active');
              
              t('.swiper-pagination .swiper-pagination-bullet').removeClass('swiper-pagination-bullet-active');
              t('.swiper-pagination .swiper-pagination-bullet:nth-child(' + navActive + ')').addClass('swiper-pagination-bullet-active');
              t('.gallery-top .swiper-wrapper').css('transform', 'translate3d(-' + transform + 'px, 0px, 0px)');
              t('.gallery-top .swiper-wrapper').css('height', height);
              
            },
            _preloadVariantMediaImages: function () {
                t(mt.variantMediaImage, this.$container).addClass(pt.lazyPreload);
            },
            _formatVariantSelectors: function () {
                B.promiseStylesheet().then(
                    function () {
                        t(mt.selectorWrapper, this.$container).each(function () {
                            var e = t(this),
                                i = e.find("label");
                            e.find("select, input").css({ "padding-left": i.outerWidth(), opacity: 1 });
                        });
                    }.bind(this)
                );
            },
            _updatedContainer: function (e) {
                var i = this.$container.clone();
                return t(mt.masterSelect, i).val(e.id), this._updateInputValues(e, i), this._updateProductPrices(e, i), this._updateVariantMediaImage(e, i), this._toggleVariantMediaHide(e, i), this._updateCartButtonState(e, i), i[0];
            },
            _updateInputValues: function (e, i) {
                t(mt.optionInputs, i).each(function (i) {
                    t(this).val(e.options[i]);
                });
            },
            _updateCartButtonState: function (e, i) {
                var n;
                (n = e.isUndefined ? theme.strings.unavailable : e.available ? theme.strings.addToCart : theme.strings.soldOut),
                    this._resetAddToCartButton(i),
                    e.available ? t(mt.shopifyPaymentButton, i).show() : t(mt.shopifyPaymentButton, i).hide(),
                    t(mt.submitButton, i).prop("disabled", !e.available).attr("aria-label", n),
                    t(mt.submitButtonPrimaryText, i).text(n);
            },
            _updateProductPrices: function (e, i) {
                var n = e.price,
                    s = e.compare_at_price;
                t(mt.regularPrice, i).html(G.formatMoney(n, theme.moneyFormat)),
                    t(mt.compareAtPrice, i).html(G.formatMoney(s, theme.moneyFormat)),
                    t(mt.productPrice, i).toggleClass(pt.productPriceSale, s > n),
                    t(mt.unitPriceContainer, i).addClass(pt.productPriceUnitUnavailable),
                    e.unit_price_measurement &&
                        (t(mt.unitPrice, i).html(G.formatMoney(e.unit_price, theme.moneyFormat)), t(mt.unitPriceBaseUnit, i).html(this.getBaseUnit(e)), t(mt.unitPriceContainer, i).removeClass(pt.productPriceUnitUnavailable));
            },
            _updateVariantMediaImage: function (e, i) {
                var n = t(mt.variantMediaImage, i);
                if (this.product.media && n.length) {
                    var s = (e.featured_media && e.featured_media.preview_image.src) || this.product.media[0].preview_image.src,
                        o = J.imageSize(n.attr("src")),
                        a = J.getSizedImageUrl(s, o);
                    n.attr("src", a);
                }
            },
            _toggleVariantMediaHide: function (e, i) {
                if (e.featured_media || this.product.featured_media) {
                    var n = e.featured_media || this.product.featured_media.id,
                        s = n && n.id,
                        o = this.id + "-" + s;
                    t(mt.variantMediaToggleHide, i)
                        .filter('[data-media-id="' + o + '"]')
                        .removeClass(pt.hide)
                        .siblings()
                        .not(mt.shopifyXr)
                        .addClass(pt.hide);
                }
            },
            _addItemToCart: function (e) {
                if (z.isInstance("cart-drawer")) {
                    e.preventDefault();
                    var i = t(mt.submitButton, this.$container),
                        n = new FormData(e.target);
                    i.hasClass(pt.ajaxCartToggle) ||
                        Y.addItemFromForm(n)
                            .then(this._transitionAddToCartButton.bind(this, n))
                            .catch(this._onAddItemFail.bind(this))
                            .always(
                                function () {
                                    this.trigger("variant_add_to_cart", [this.product, this.variant, n]);
                                }.bind(this)
                            );
                }
            },
            _onAddItemFail: function (e) {
                var i = t(mt.notification, this.$container),
                    n = e && e.responseText;
                return (
                    (n = n ? JSON.parse(n).description : theme.strings.cartError),
                    i.addClass(pt.productNotificationError).removeClass(pt.productNotificationSuccess).html(n).attr("role", "alert"),
                    this.trigger("variant_add_to_cart_fail", [this.product, this.variant, n]),
                    B.promiseTransitionEnd(i)
                );
            },
            _transitionAddToCartButton: function (e) {
                var i = t(mt.notification, this.$container),
                    n = t(mt.submitButton, this.$container),
                    s = t(mt.submitButtonPrimaryText, n),
                    o = t(mt.submitButtonSecondaryText, n);
                return (
                    n.addClass([pt.buttonTransition, pt.ajaxCartToggle].join(" ")).attr("aria-label", theme.strings.viewCart),
                    s.attr("aria-hidden", !0),
                    o.attr("aria-hidden", !1),
                    i.removeClass(pt.productNotificationError).addClass(pt.productNotificationSuccess).text(theme.strings.addItemSuccess).attr("role", "alert"),
                    this.trigger("variant_add_to_cart_successful", [this.product, this.variant, e]),
                    B.promiseTransitionEnd(i)
                );
            },
            _resetAddToCartButton: function (e) {
                e = e.length ? e : this.$container;
                var i = t(mt.notification, e),
                    n = t(mt.submitButton, e),
                    s = t(mt.submitButtonPrimaryText, n),
                    o = t(mt.submitButtonSecondaryText, n);
                n.removeClass([pt.buttonTransition, pt.ajaxCartToggle].join(" ")).attr("aria-label", theme.strings.addToCart),
                    s.attr("aria-hidden", !1),
                    o.attr("aria-hidden", !0),
                    i.removeClass(pt.productNotificationError).removeClass(pt.productNotificationSuccess).text("").attr("role", "");
            },
            _updateOnlineStatus: function () {
                theme.isOnline = !0;
            },
            _updateOfflineStatus: function () {
                theme.isOnline = !1;
            },
            getBaseUnit: function (t) {
                return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
            },
        },
        gt = { link: "link", script: "script" },
        vt = { requested: "requested", loaded: "loaded" },
        _t = "https://cdn.shopify.com/shopifycloud/",
        bt = {
            plyrShopifyStyles: { tagId: "plyr-shopify-styles", src: _t + "shopify-plyr/v1.0/shopify-plyr.css", type: gt.link },
            modelViewerUiStyles: { tagId: "shopify-model-viewer-ui-styles", src: _t + "model-viewer-ui/assets/v1.0/model-viewer-ui.css", type: gt.link },
        },
        St = {
            load: function (t, e) {
                var i = bt[t];
                if (i && i.status !== vt.requested) {
                    if (((e = e || function () {}), i.status === vt.loaded)) return void e();
                    i.status = vt.requested;
                    var n;
                    switch (i.type) {
                        case gt.script:
                            n = this._createScriptTag(i, e);
                            break;
                        case gt.link:
                            n = this._createLinkTag(i, e);
                    }
                    (n.id = i.tagId), (i.element = n);
                    var s = document.getElementsByTagName(i.type)[0];
                    s.parentNode.insertBefore(n, s);
                }
            },
            _createScriptTag: function (t, e) {
                var i = document.createElement("script");
                return (
                    (i.src = t.src),
                    i.addEventListener("load", function () {
                        (t.status = vt.loaded), e();
                    }),
                    i
                );
            },
            _createLinkTag: function (t, e) {
                var i = document.createElement("link");
                return (
                    (i.href = t.src),
                    (i.rel = "stylesheet"),
                    (i.type = "text/css"),
                    B.promiseStylesheet(t.src).then(function () {
                        (t.status = vt.loaded), e();
                    }),
                    i
                );
            },
        },
        yt = {},
        wt = {},
        Ct = {},
        $t = { mediaGroup: "[data-media-group]", productMediaTypeModel: "[data-product-media-type-model]", xrButton: "[data-shopify-xr]" },
        kt = { modelJson: "data-model-json", productSlideshowSlide: "data-product-slideshow-slide" },
        xt = { slideActive: "slider__slide--active" },
        Tt = {
            initModelViewers: function (e) {
                B.isTouch();
                var i = e || this.$container,
                    n = t($t.productMediaTypeModel, i);
                (t($t.xrButton, i).length || n.length) && this._initModelViewerLibraries(n);
            },
            removeSectionModels: function () {
                for (var t in wt)
                    if (wt.hasOwnProperty(t)) {
                        var e = wt[t];
                        e.sectionId === this.id && (e.modelViewerUi.destroy(), delete wt[t]);
                    }
                delete yt[this.id];
            },
            _initModelViewerLibraries: function (e) {
                yt[this.id] = { loaded: !1 };
                var i = this.id;
                e.each(function (e) {
                    var n = t(this),
                        s = n.data("media-id"),
                        o = t(n.find("model-viewer")[0]),
                        a = o.data("model-id");
                    if (0 === e) {
                        var r = n.closest($t.mediaGroup).find($t.xrButton);
                        Ct[i] = { $element: r, defaultId: a };
                    }
                    wt[s] = { modelId: a, sectionId: i, $container: n, $element: o };
                }),
                    window.Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: this._setupShopifyXr.bind(this) }]),
                    e.length && (window.Shopify.loadFeatures([{ name: "model-viewer-ui", version: "1.0", onLoad: this._setupModelViewerUi.bind(this) }]), St.load("modelViewerUiStyles"));
            },
            _setupShopifyXr: function (e) {
                if (!e) {
                    if (!window.ShopifyXR)
                        return void document.addEventListener(
                            "shopify_xr_initialized",
                            function () {
                                this._setupShopifyXr();
                            }.bind(this)
                        );
                    for (var i in yt)
                        if (yt.hasOwnProperty(i)) {
                            var n = yt[i];
                            if (n.loaded) continue;
                            var s = t("[" + kt.modelJson + '="' + i + '"]');
                            window.ShopifyXR.addModels(JSON.parse(s.html())), (n.loaded = !0);
                        }
                    window.ShopifyXR.setupXRElements();
                }
            },
            _setupModelViewerUi: function (t) {
                if (!t)
                    for (var e in wt)
                        if (wt.hasOwnProperty(e)) {
                            var i = wt[e];
                            i.modelViewerUi || (i.modelViewerUi = new Shopify.ModelViewerUI(i.$element, { iconUrl: theme.modelViewerUiSprite })), this._setupModelViewerListeners(i);
                        }
            },
            updateShopifyXr: function (t, e) {
                var i = Ct[t];
                if (i) {
                    var n = e ? wt[e].modelId : i.defaultId;
                    i.$element.attr("data-shopify-model3d-id", n);
                }
            },
            _setupModelViewerListeners: function (t) {
                var e = t.$container;
                e[0].hasAttribute(kt.productSlideshowSlide) &&
                    (t.$element
                        .on("shopify_model_viewer_ui_toggle_play", function () {
                            e.hasClass(xt.slideActive) && e.trigger("mediaSlideIsDraggable", [!1]);
                        })
                        .on("shopify_model_viewer_ui_toggle_pause", function () {
                            e.hasClass(xt.slideActive) && e.trigger("mediaSlideIsDraggable", [!0]);
                        }),
                    t.$container.on("mediaVisible", function () {
                        B.isTouch() || t.modelViewerUi.play();
                    }),
                    t.$container
                        .on("mediaHidden", function () {
                            t.modelViewerUi.pause();
                        })
                        .on("xrLaunch", function () {
                            t.modelViewerUi.pause();
                        }));
            },
        },
        Pt = {
            promiseAPI: function () {
                if (!ct) {
                    var e = document.createElement("script");
                    e.src = "https://www.youtube.com/iframe_api";
                    var i = document.getElementsByTagName("script")[0];
                    i.parentNode.insertBefore(e, i),
                        (ct = t.Deferred(function (t) {
                            (window.onYouTubeIframeAPIReady = t.resolve),
                                setTimeout(function () {
                                    t.reject("Request for YouTube API timed out after 30 seconds.");
                                }, 3e4);
                        }));
                }
                return ct;
            },
            promisePlayer: function (e, i) {
                return this.promiseAPI().then(function () {
                    return t.Deferred(function (t) {
                        void 0 === window.YT && t.reject("We're sorry, something went wrong. The YouTube API has not loaded correctly.");
                        var n = new YT.Player(e, i);
                        n.addEventListener("onReady", function () {
                            t.resolve(n);
                        }),
                            setTimeout(function () {
                                t.reject("Request for YouTube player has timed out after 30 seconds.");
                            }, 3e4);
                    });
                });
            },
        },
        At = {},
        Bt = { html5: "html5", youtube: "youtube" },
        Et = { productMediaWrapper: "[data-product-media-wrapper]", productMediaTypeVideo: "[data-product-media-type-video]" },
        It = { enableVideoLooping: "enable-video-looping", videoId: "video-id", productMediaSlide: "data-product-slideshow-slide" },
        Mt = {
            initProductVideos: function (e) {
                B.isTouch();
                var i = e || this.$container;
                t(Et.productMediaTypeVideo, i).each(
                    function (e, i) {
                        var n = t(i);
                        this._setupProductVideo(n);
                    }.bind(this)
                );
            },
            removeSectionVideos: function (t) {
                for (var e in At)
                    if (At.hasOwnProperty(e)) {
                        var i = At[e];
                        i.sectionId === t && (i.player && i.player.destroy(), delete At[e]);
                    }
            },
            _setupProductVideo: function (t) {
                if (t.length) {
                    var e = t.find("iframe, video")[0],
                        i = t.data("media-id"),
                        n = this;
                    if (e) {
                        At[i] = {
                            mediaId: i,
                            sectionId: n.id,
                            host: n._hostFromVideoElement(e),
                            $container: t,
                            element: e,
                            ready: function () {
                                n._createPlayer(this);
                            },
                        };
                        switch (At[i].host) {
                            case Bt.html5:
                                window.Shopify.loadFeatures([{ name: "video-ui", version: "1.1", onLoad: this._setupPlyrVideos.bind(this) }]), St.load("plyrShopifyStyles");
                                break;
                            case Bt.youtube:
                                this._loadVideos(Bt.youtube);
                        }
                    }
                }
            },
            _setupPlyrVideos: function (t) {
                if (t) return void this._fallbackToNativeVideo();
                this._loadVideos(Bt.html5);
            },
            _createPlayer: function (e) {
                if (!e.player) {
                    var i = e.$container.closest(Et.productMediaWrapper),
                        n = t(i)[0].hasAttribute(It.productMediaSlide),
                        s = i.data(It.enableVideoLooping);
                    switch (e.host) {
                        case Bt.html5:
                            (e.player = new Shopify.Plyr(e.element, { loop: { active: s }, iconUrl: theme.plyrSprite })),
                                n &&
                                    (e.player.on("seeking", function () {
                                        i.trigger("mediaSlideIsDraggable", [!1]);
                                    }),
                                    e.player.on(
                                        "seeked",
                                        d(function () {
                                            i.trigger("mediaSlideIsDraggable", [!0]);
                                        }, 1e3)
                                    ));
                            break;
                        case Bt.youtube:
                            var o = i.data(It.videoId);
                            if (e.requested) return;
                            (e.requested = !0),
                                Pt.promisePlayer(e.element, {
                                    videoId: o,
                                    events: {
                                        onStateChange: function (t) {
                                            0 === t.data && s && t.target.seekTo(0);
                                        },
                                    },
                                })
                                    .then(function (t) {
                                        e.player = t;
                                    })
                                    .catch(function (t) {
                                        console.error(t);
                                    });
                    }
                    i.on("mediaHidden xrLaunch", function () {
                        e.player && (e.host === Bt.html5 && e.player.pause(), e.host === Bt.youtube && e.player.pauseVideo && e.player.pauseVideo());
                    }),
                        i.on("mediaVisible", function () {
                            B.isTouch() || (e.player && (e.host === Bt.html5 && e.player.play(), e.host === Bt.youtube && e.player.playVideo && e.player.playVideo()));
                        });
                }
            },
            _hostFromVideoElement: function (t) {
                return "VIDEO" === t.tagName ? Bt.html5 : "IFRAME" === t.tagName && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(t.src) ? Bt.youtube : null;
            },
            _loadVideos: function (t) {
                for (var e in At)
                    if (At.hasOwnProperty(e)) {
                        var i = At[e];
                        i.host === t && i.ready();
                    }
            },
            _fallbackToNativeVideo: function () {
                for (var t in At)
                    if (At.hasOwnProperty(t)) {
                        var e = At[t];
                        if (e.nativeVideo) continue;
                        e.host === Bt.html5 && (e.element.setAttribute("controls", "controls"), (e.nativeVideo = !0));
                    }
            },
        },
        Dt = { socialSharing: ".social-sharing", detailsButton: ".product__more-details" };
    z.register("featured-product", {
        onLoad: function () {
            this.extend(F),
                this.extend(ft),
                this.extend(Tt),
                this.extend(Mt),
                this.initModelViewers(),
                this.initProductVideos(),
                this.on("variant_change", this._updateProductLink.bind(this)),
                this.window().on("resize", d(this._formatVariantSelectors.bind(this), 500));
        },
        _updateProductLink: function (e, i, n, s) {
            var o = t(Dt.detailsButton, this.$container),
                a = B.updateUrlParameter(o.attr("href"), "variant", s.id);
            o.attr("href", a);
        },
        onUnload: function () {
            this.removeSectionVideos(this.id), this.removeSectionModels(this.id);
        },
    });
    var Ft = { slides: ".slider__slide", activeSlide: ".slider__slide--active" },
        Ht = { activeSlide: "slider__slide--active", previousSlide: "slider__slide--previous", nextSlide: "slider__slide--next", transitioningSlide: "slider__slide--transitioning", draggingSlide: "slider__slide--dragging" },
        Lt = { nextSlide: "nextslide", prevSlide: "prevslide", transitionStart: "slidetransitionstart", transitionEnd: "slidetransitionend" },
        Ot = { moveThreshold: 25 };
    x.prototype = t.extend({}, x.prototype, {
        destroy: function () {
            return this.$element.off("touchstart mousedown"), this.$slides.length && (this.$slides[0].removeEventListener("focus", this.bindedOnFocus, !0), this.$slides[0].removeEventListener("blur", this.bindedOnBlur, !0)), null;
        },
        nextSlide: function () {
            return (
                this._triggerEvent([Lt.nextSlide, Lt.transitionStart]),
                this._promiseNextSlide().then(
                    function () {
                        this._triggerEvent(Lt.transitionEnd);
                    }.bind(this)
                )
            );
        },
        previousSlide: function () {
            return (
                this._triggerEvent([Lt.prevSlide, Lt.transitionStart]),
                this._promisePrevSlide().then(
                    function () {
                        this._triggerEvent(Lt.transitionEnd);
                    }.bind(this)
                )
            );
        },
        setSlide: function (e, i) {
            var n = this.slidePromiseChain || t.Deferred().resolve(),
                s = this.$currentSlide.index(),
                o = this.$slides.length,
                a = t.Deferred().resolve();
            return (
                (this.slidePromiseChain = n.then(
                    function () {
                        return (
                            e < o &&
                                e !== s &&
                                (i ? (e > s ? (a = B.promiseRepeatSeries(this.nextSlide.bind(this), e - s)) : e < s && (a = B.promiseRepeatSeries(this.previousSlide.bind(this), s - e))) : (a = this._promiseSlide(this.$slides.eq(e)))),
                            a
                        );
                    }.bind(this)
                )),
                this.slidePromiseChain
            );
        },
        setIsDraggable: function (t) {
            this.isDraggable = t;
        },
        shouldPreventSlide: function (e, i, n) {
            return !!(n < 2 || t(e).closest(i.join(",")).length);
        },
        _promiseNextSlide: function () {
            return (
                requestAnimationFrame(
                    function () {
                        this.$nextSlide.addClass(Ht.nextSlide),
                            requestAnimationFrame(
                                function () {
                                    this.$slides.removeAttr("style"),
                                        this.$nextSlide.removeClass(Ht.nextSlide).addClass(Ht.activeSlide).addClass(Ht.transitioningSlide),
                                        this.$currentSlide.removeClass(Ht.activeSlide).addClass(Ht.previousSlide).addClass(Ht.transitioningSlide);
                                }.bind(this)
                            );
                    }.bind(this)
                ),
                this._promiseSlideTransitionEnd().then(
                    function () {
                        this._setCurrentSlide(this.$nextSlide);
                    }.bind(this)
                )
            );
        },
        _promisePrevSlide: function () {
            return (
                requestAnimationFrame(
                    function () {
                        this.$previousSlide.addClass(Ht.previousSlide),
                            requestAnimationFrame(
                                function () {
                                    this.$slides.removeAttr("style"),
                                        this.$previousSlide.removeClass(Ht.previousSlide).addClass(Ht.activeSlide).addClass(Ht.transitioningSlide),
                                        this.$currentSlide.removeClass(Ht.activeSlide).addClass(Ht.nextSlide).addClass(Ht.transitioningSlide);
                                }.bind(this)
                            );
                    }.bind(this)
                ),
                this._promiseSlideTransitionEnd().then(
                    function () {
                        this._setCurrentSlide(this.$previousSlide);
                    }.bind(this)
                )
            );
        },
        _promiseSlide: function (e) {
            return (
                this._setCurrentSlide(e),
                e.addClass(Ht.activeSlide).siblings().removeClass(Ht.activeSlide),
                t.Deferred(
                    function (t) {
                        requestAnimationFrame(
                            function () {
                                this._triggerEvent(Lt.transitionEnd), t.resolve();
                            }.bind(this)
                        );
                    }.bind(this)
                )
            );
        },
        _promiseCancelSlide: function () {
            return (
                requestAnimationFrame(
                    function () {
                        this.$slides.removeAttr("style").addClass(Ht.transitioningSlide);
                    }.bind(this)
                ),
                this._promiseSlideTransitionEnd()
            );
        },
        _promiseSlideTransitionEnd: function () {
            return t.Deferred(
                function (t) {
                    this.$currentSlide.one(
                        "transitionend",
                        function () {
                            this.$slides.removeClass([Ht.transitioningSlide, Ht.nextSlide, Ht.previousSlide].join(" ")), t.resolve();
                        }.bind(this)
                    );
                }.bind(this)
            );
        },
        _setCurrentSlide: function (t) {
            (this.$currentSlide = t), (this.$nextSlide = this._nextSlideIndex(t, this.$slides)), (this.$previousSlide = this._prevSlideIndex(t, this.$slides));
        },
        _assignTouchHandlers: function () {
            (this.bindedTouchStart = this._onTouchStart.bind(this)),
                (this.bindedTouchMove = this._onTouchMove.bind(this)),
                (this.bindedTouchEnd = this._onTouchEnd.bind(this)),
                this.$element.one("touchstart", this.bindedTouchStart).one("mousedown", this.bindedTouchStart);
        },
        _onTouchStart: function (e) {
            (this.windowWidth = t(window).innerWidth()), (this.startPosition = B.pointerEventToXY(e)), (this.isDragging = !1), this.$element.on("touchmove mousemove", this.bindedTouchMove).on("touchend mouseup", this.bindedTouchEnd);
        },
        _onTouchMove: function (t) {
            this.isDraggable &&
                ((this.currentPosition = B.pointerEventToXY(t)),
                (this.percentMoved = ((this.currentPosition.x - this.startPosition.x) / this.windowWidth) * 100),
                this.isDragging || (this.isDragging = !0),
                this.percentMoved > 0
                    ? (this.$previousSlide.addClass(Ht.previousSlide), this.$nextSlide.removeClass(Ht.nextSlide), this.$previousSlide.css({ transform: "translateX(" + (this.percentMoved - 100) + "%)" }))
                    : (this.$previousSlide.removeClass(Ht.previousSlide), this.$nextSlide.addClass(Ht.nextSlide), this.$nextSlide.css({ transform: "translateX(" + (100 + this.percentMoved) + "%)" })),
                this.$currentSlide.addClass(Ht.draggingSlide).css({ transform: "translateX(" + this.percentMoved + "%)" }));
        },
        _onTouchEnd: function () {
            var e = this.config.moveThreshold,
                i = t.Deferred().resolve();
            this.$element.off(),
                this.isDragging && ((this.isDragging = !1), this.$currentSlide.removeClass(Ht.draggingSlide), (i = this.percentMoved > e ? this.previousSlide() : this.percentMoved < -e ? this.nextSlide() : this._promiseCancelSlide())),
                i.then(
                    function () {
                        this.$element.one("touchstart", this.bindedTouchStart).one("mousedown", this.bindedTouchStart);
                    }.bind(this)
                );
        },
        _onFocus: function () {
            this.$element.one("keyup", this._onKeyup.bind(this));
        },
        _onBlur: function () {
            this.$element.off("keyup");
        },
        _onKeyup: function (e) {
            var i = t.Deferred().resolve(),
                n = !1,
                s = this.shouldPreventSlide(e.target, [".plyr", ".shopify-model-viewer-ui"], this.$slides.length);
            switch (e.keyCode) {
                case 37:
                    if (s) break;
                    (i = this.previousSlide()), (n = t.contains(this.$element[0], document.activeElement));
                    break;
                case 39:
                    if (s) break;
                    (i = this.nextSlide()), (n = t.contains(this.$element[0], document.activeElement));
            }
            i.then(
                function () {
                    n && this.$element.focus(), this.$element.one("keyup", this._onKeyup.bind(this));
                }.bind(this)
            );
        },
        _triggerEvent: function (t) {
            "string" == typeof t && (t = [t]),
                t.forEach(
                    function (t) {
                        this.$element.trigger(t, { $previousSlide: this.$previousSlide, $currentSlide: this.$currentSlide, $nextSlide: this.$nextSlide });
                    }.bind(this)
                );
        },
        _nextSlideIndex: function (t, e) {
            var i = t.index(),
                n = e.length,
                s = i + 1;
            return i + 1 === n && (s = 0), e.eq(s);
        },
        _prevSlideIndex: function (t, e) {
            var i = t.index(),
                n = e.length,
                s = i - 1;
            return i - 1 == -1 && (s = n - 1), e.eq(s);
        },
    });
    var Vt = {
            coverTopBackground: ".reveal-slider__cover-background--top",
            coverBottomBackground: ".reveal-slider__cover-background--bottom",
            coverContent: ".reveal-slider__cover-content",
            slideNavButtons: ".reveal-slider__nav-button",
            slidePreviousButton: ".reveal-slider__previous-button",
            slideNextButton: ".reveal-slider__next-button",
            closeCoverButton: ".reveal-slider__close",
            slider: ".slider",
        },
        Nt = { navButtonActive: "active", coverOpen: "open" },
        Rt = {
            initRevealSlider: function () {
                this.trigger("reveal_slider_init_start"),
                    (this.revealSlider = !0),
                    (this.coverIsOpen = !1),
                    (this.revealSliderNamespace = ".revealSlider"),
                    (this.mediaQuerySmall = theme.mediaQuerySmall),
                    (this.slider = new x(t(Vt.slider, this.$container))),
                    (this.hammertime = new p(this.$container[0])),
                    this.on("click", Vt.slideNavButtons, this._onClickNavButton.bind(this)),
                    this.on("click", Vt.slidePreviousButton, this.slider.previousSlide.bind(this.slider)),
                    this.on("click", Vt.slideNextButton, this.slider.nextSlide.bind(this.slider)),
                    this.on("click", Vt.closeCoverButton, this.closeCover.bind(this)),
                    this.on("click", Vt.coverContent, this.openCover.bind(this)),
                    this.on("nextslide prevslide", this._changeBackgroundColor.bind(this)),
                    this.on("slidetransitionend", this._onSlideTransitionEnd.bind(this)),
                    this.document().on("touchstart" + this.revealSliderNamespace, this._onTouchStart.bind(this)),
                    this.document().on("touchend" + this.revealSliderNamespace, this._onTouchEnd.bind(this)),
                    this.hammertime.on("pinchout pinchin", this._onPinch.bind(this)).on("pinchend pinchcancel", this._onPinchEnd.bind(this)),
                    this.trigger("reveal_slider_init_done");
            },
            destroyRevealSlider: function () {
                (this.revealSlider = !1), (this.slider = this.slider.destroy()), this.document().off(this.revealSliderNamespace), this.off(), this.trigger("reveal_slider_destroy");
            },
            openCover: function () {
                this.$container.addClass(Nt.coverOpen), (this.coverIsOpen = !0), this.trigger("reveal_slider_open_cover");
            },
            closeCover: function () {
                this.$container.removeClass(Nt.coverOpen), (this.coverIsOpen = !1), this.trigger("reveal_slider_close_cover");
            },
            _changeBackgroundColor: function (e, i) {
                var n;
                (n = "nextslide" === e.type ? i.$nextSlide.data("background-color") : i.$previousSlide.data("background-color")), t(Vt.slider, this.$container).css({ backgroundColor: n });
            },
            _onSlideTransitionEnd: function (e, i) {
                var n = i.$currentSlide.index();
                t(Vt.slideNavButtons, this.$container).eq(n).addClass(Nt.navButtonActive).siblings().removeClass(Nt.navButtonActive);
            },
            _onClickNavButton: function (e) {
                var i = t(e.target),
                    n = i.index();
                this.slider.setSlide(i.index()), this.trigger("reveal_slider_set_slide", [n]);
            },
            _onTouchStart: function (t) {
                t.originalEvent.touches.length <= 1 || ((this.enablePinch = !0), this.hammertime.get("pinch").set({ enable: this.enablePinch }));
            },
            _onTouchEnd: function () {
                this.enablePinch && ((this.enablePinch = !1), this.hammertime.get("pinch").set({ enable: this.enablePinch }));
            },
            _onPinch: function (e) {
                (this.$coverTopBackground = this.$coverTopBackground || t(Vt.coverTopBackground, this.$container)),
                    (this.$coverBottomBackground = this.$coverBottomBackground || t(Vt.coverBottomBackground, this.$container)),
                    (this.$coverTitle = this.$coverTitle || t(Vt.coverContent, this.$container)),
                    ("pinchin" === e.type && !this.coverIsOpen) ||
                        ("pinchout" === e.type && this.coverIsOpen) ||
                        ((this.distance = this.coverIsOpen ? 70 * e.scale : 25 * (e.scale - 1)),
                        this.distance < 0 && (this.distance = 0),
                        this.$coverBottomBackground.css({ transform: "translateY(" + this.distance + "%)" }),
                        this.$coverTopBackground.css({ transform: "translateY(-" + this.distance + "%)" }),
                        this.$coverTitle.css({ opacity: 1 - this.distance / 30 }));
            },
            _onPinchEnd: function (t) {
                t.scale > 2 ? (this.$container.addClass(Nt.coverOpen), (this.coverIsOpen = !0)) : (this.$container.removeClass(Nt.coverOpen), (this.coverIsOpen = !1)),
                    requestAnimationFrame(
                        function () {
                            this.$coverTopBackground.removeAttr("style"), this.$coverBottomBackground.removeAttr("style"), this.$coverTitle.removeAttr("style");
                        }.bind(this)
                    );
            },
        },
        Wt = { coverContent: ".side-scroller__cover-content", slidesContainer: ".side-scroller__slides-container", coverBackground: ".side-scroller__cover-background", slides: ".side-scroller__slide" },
        qt = { coverFixed: "side-scroller--fixed", coverBottom: "side-scroller--fixed-bottom" },
        jt = {
            initSideScroller: function () {
                this.trigger("side_scroller_init_start"),
                    (this.$slides = t(Wt.slides, this.$container)),
                    (this.$slidesContainer = t(Wt.slidesContainer, this.$container)),
                    (this.sideScroller = !0),
                    (this.sideScrollerNamespace = ".sideScroller"),
                    (this.coverPosition = "top"),
                    this.window().on("scroll" + this.sideScrollerNamespace, this._onScroll.bind(this)),
                    this.window().on("resize" + this.sideScrollerNamespace, this._updateCoverPositionValues.bind(this)),
                    this.window().on("resize" + this.sideScrollerNamespace, this._onScroll.bind(this)),
                    this.document().on("drawer_open_start" + this.sideScrollerNamespace, this._handleFixedSideImage.bind(this)),
                    this.document().on("drawer_close_done" + this.sideScrollerNamespace, this._resetFixedSideImage.bind(this)),
                    B.promiseStylesheet().then(
                        function () {
                            this._updateCoverPositionValues(), this._onScroll(), this.trigger("side_scroller_init_done");
                        }.bind(this)
                    );
            },
            destroySideScroller: function () {
                (this.sideScroller = !1), this.window().off(this.sideScrollerNamespace), this.document().off(this.sideScrollerNamespace), this.trigger("side_scroller_destroy");
            },
            _handleFixedSideImage: function () {
                if ("fixed" === this.coverPosition) {
                    var e = t(Wt.coverContent, this.$container),
                        i = e.outerHeight(),
                        n = t(window).scrollTop(),
                        s = n - this.featuresOffset.top;
                    t(Wt.coverBackground, this.$container).css({ transform: "translateY(" + s + "px)", position: "absolute" }),
                        t(Wt.coverContent, this.$container).css({ transform: "translate(-50%, " + (s - i / 2) + "px)", position: "absolute" });
                }
            },
            _resetFixedSideImage: function () {
                "fixed" === this.coverPosition && t(Wt.coverBackground, this.$container).add(Wt.coverContent, this.$container).css({ transform: "", position: "" });
            },
            _onScroll: function () {
                var e = t(window).scrollTop();
                e > this.featuresOffset.top && e + this.windowHeight <= this.featuresOffset.top + this.featuresHeight
                    ? (requestAnimationFrame(this._setCoverPosition.bind(this, "fixed")), requestAnimationFrame(this._updateBackgroundColor.bind(this, e)))
                    : e + this.windowHeight > this.featuresOffset.top + this.featuresHeight
                    ? requestAnimationFrame(this._setCoverPosition.bind(this, "bottom"))
                    : requestAnimationFrame(this._setCoverPosition.bind(this, "top"));
            },
            _setCoverPosition: function (t) {
                if (this.coverPosition !== t)
                    switch (t) {
                        case "top":
                            this.$container.removeClass([qt.coverBottom, qt.coverFixed].join(" ")), this.trigger("side_scroller_position_top");
                            break;
                        case "fixed":
                            this.$container.removeClass(qt.coverBottom).addClass(qt.coverFixed), this.trigger("side_scroller_position_fixed");
                            break;
                        case "bottom":
                            this.$container.removeClass(qt.coverFixed).addClass(qt.coverBottom), this.trigger("side_scroller_position_bottom");
                    }
                this.coverPosition = t;
            },
            _updateBackgroundColor: function (t) {
                var e = Math.floor((t - this.featuresOffset.top + this.windowHeight / 2) / this.slideHeight);
                (this.currentBackgroundIndex = this.currentBackgroundIndex || 0),
                    e !== this.currentBackgroundIndex && ((this.currentBackgroundIndex = e), this.$slidesContainer.css({ backgroundColor: this.$slides.eq(e).data("background-color") }));
            },
            _updateCoverPositionValues: function () {
                (this.slideHeight = this.$slides.first().height()),
                    (this.featuresOffset = this.$container.offset()),
                    (this.featuresHeight = this.$container.height()),
                    (this.windowHeight = t(window).innerHeight()),
                    (this.windowWidth = t(window).innerWidth());
            },
        };
    z.register("featured-slider", {
        onLoad: function () {
            (this.coverIsOpen = !1), this.extend(Rt), this.extend(jt), this._toggleViewState(), t(window).on("resize", d(this._toggleViewState.bind(this)));
        },
        onUnload: function () {
            this._destroyDesktopState(), this._destroyMobileState();
        },
        onDeselect: function () {
            this.mobileViewEnabled && this.closeCover();
        },
        onBlockSelect: function (e) {
            this.mobileViewEnabled ? (this.openCover(), this.slider.setSlide(t(e.target).index())) : t("html, body").animate({ scrollTop: t(e.target).offset().top }, 400);
        },
        onBlockDeselect: function () {
            this.mobileViewEnabled && this.revealSlider.closeCover();
        },
        _toggleViewState: function () {
            var e,
                i,
                n = t(window).innerWidth();
            void 0 === this.mobileViewEnabled ? ((e = n < theme.mediaQuerySmall), (i = n >= theme.mediaQuerySmall)) : ((e = n < theme.mediaQuerySmall && !this.mobileViewEnabled), (i = n >= theme.mediaQuerySmall && this.mobileViewEnabled)),
                e && ((this.mobileViewEnabled = !0), this._destroyDesktopState(), this._enableMobileState()),
                i && ((this.mobileViewEnabled = !1), this._destroyMobileState(), this._enableDesktopState());
        },
        _enableDesktopState: function () {
            this.initSideScroller();
        },
        _destroyDesktopState: function () {
            void 0 !== this.sideScroller && this.destroySideScroller();
        },
        _enableMobileState: function () {
            this.initRevealSlider();
        },
        _destroyMobileState: function () {
            this.revealSlider && this.destroyRevealSlider();
        },
    });
    var Ut = { footerParallax: "site-footer--parallax" },
        zt = { contentForLayout: ".content-for-layout", footerCover: ".site-footer__drawer-cover " };
    z.register("footer", {
        onLoad: function () {
            !this.container.hasAttribute("data-footer-parallax") ||
                (t("html").hasClass("is-ios") && Shopify.designMode) ||
                (this.window().on("resize", this._setParallax.bind(this)),
                this.document().on("drawer_open_start", this._handleDrawerOpenState.bind(this)),
                this.document().on("drawer_close_done", this._resetDrawerOpenState.bind(this)),
                t(document.body).addClass(Ut.footerParallax),
                B.promiseStylesheet().then(this._setParallax.bind(this)));
        },
        onUnload: function () {
            t(document.body).removeClass(Ut.footerParallax), t(zt.contentForLayout).css("margin-bottom", "");
        },
        _setParallax: function () {
            (this.height = this.$container.innerHeight()), t(zt.contentForLayout).css("margin-bottom", this.height);
        },
        _handleDrawerOpenState: function () {
            if (document.body.scrollHeight - window.innerHeight == 0) this.$container.css("margin-bottom", document.body.clientHeight - document.body.scrollHeight);
            else {
                var e = document.body.scrollHeight - window.innerHeight - window.scrollY,
                    i = e - this.height;
                this.$container.css("margin-bottom", i), t(zt.footerCover).css("height", e).show();
            }
        },
        _resetDrawerOpenState: function () {
            this.$container.css("margin-bottom", ""), t(zt.footerCover).hide();
        },
    });
    var Qt = {
            skipLink: ".skip-link",
            navigation: ".navigation",
            navAnimateElements: ".navigation__entrance-animation",
            cartBubble: ".site-header__cart-bubble",
            siteHeader: ".site-header",
            siteHeaderWrapper: ".site-header__wrapper",
            siteHeaderLogo: ".site-header__logo",
            siteHeaderCart: ".site-header__cart",
            siteNavigation: "[data-site-navigation]",
            navigationButton: "[data-navigation-button]",
            navigationExpandSublinks: ".navigation__expand-sublinks",
            navigationExpandChildSublinks: ".navigation__expand-sublinks--third-level",
            navigationSublinksContainer: ".navigation__sublinks-container",
            navigationSublink: ".navigation__sublink",
            navigationSublinks: ".navigation__sublinks",
            navigationChildSublinks: ".navigation__sublinks--third-level",
            navigationHasSublinks: ".navigation__has-sublinks",
            announcementBar: ".announcement-bar",
            announcementBarClose: ".announcement-bar__close",
            contentForLayout: ".content-for-layout",
        },
        Kt = {
            themeEditor: "theme-editor",
            headerFixed: "site-header--fixed",
            headerHomepage: "site-header--homepage",
            headerTransparent: "site-header--transparent",
            cartBubbleVisible: "site-header__cart-bubble--visible",
            bubblePulse: "bubble-pulse",
            drawerActive: "drawer--active",
            navigationExpandChildSublinks: "navigation__expand-sublinks--third-level",
            navigationOpen: "navigation-open",
            navigationOpenEditor: "navigation-open--editor",
            navigationTransitioning: "navigation--is-transitioning",
            navigationHasSublinksCollapsed: "navigation__has-sublinks--collapsed",
            navigationEntranceActive: "navigation__entrance-animation--active",
            siteHeaderWrapperTransitioning: "site-header__wrapper--transitioning",
            announcementBarVisible: "announcement-bar--visible",
        },
        Xt = ["slideshow-section", "gallery", "hero"],
        Yt = !0,
        Gt = !1,
        Jt = !1;
    z.register("header-section", {
        onLoad: function () {
            (this.$container = t(this.container)),
                (this.$siteHeader = t(Qt.siteHeader)),
                (this.$siteHeaderWrapper = t(Qt.siteHeaderWrapper)),
                (this.scrollTop = 0),
                (this.isFixed = !1),
                (this.headerHeight = 0),
                (this.promiseChain = t.Deferred().resolve()),
                this._updateHeaderTransparency(),
                B.disableTabbingOfChildren(Qt.navigation),
                t(Qt.navigationButton).one("click", this._toggleNavigationDisplay.bind(this)).one("click", this._setSublinksMaxHeight.bind(this)),
                t(Qt.navigationExpandSublinks, this.$container).on("click", this._toggleNavigationSublinks.bind(this)),
                t(Qt.announcementBarClose, this.$container).on("click", this._closeAnnouncementBar.bind(this)),
                t("html").hasClass("is-ios") && Shopify.designMode
                    ? (this.$siteHeader.removeClass(Kt.headerHomepage), this.$siteHeader.removeClass(Kt.headerTransparent))
                    : t(document).on("scroll" + this.namespace, n(this._toggleHeaderPosition.bind(this), 200)),
                t(window).on("resize" + this.namespace, this._adjustNavigationPadding.bind(this)),
                t(document).on("shopify:section:reorder shopify:section:load", this._updateHeaderTransparency.bind(this)),
                t(document).on(
                    "shopify:section:unload",
                    function () {
                        setTimeout(this._updateHeaderTransparency.bind(this));
                    }.bind(this)
                ),
                Y.on("change", this._toggleCartBubble.bind(this)),
                B.promiseStylesheet().then(
                    function () {
                        this._setupAnnouncementBar();
                    }.bind(this)
                );
        },
        onSelect: function () {
            this._adjustNavigationPadding(), Jt || ((Gt = !0), this.showNavigation());
        },
        onDeselect: function () {
            (Gt = !1),
                setTimeout(
                    function () {
                        Gt || ((Jt = !1), (Gt = !1), this.hideNavigation());
                    }.bind(this),
                    100
                );
        },
        _setupAnnouncementBar: function () {
            var e = t(Qt.announcementBar, this.$container);
            e.length &&
                ((B.isSessionStorageSupported() && sessionStorage.getItem("announcement-bar-hidden")) ||
                    requestAnimationFrame(
                        function () {
                            e.addClass(Kt.announcementBarVisible),
                                this.$siteHeaderWrapper.css("margin-top", "-" + e.outerHeight() + "px"),
                                requestAnimationFrame(
                                    function () {
                                        this.$siteHeaderWrapper.addClass(Kt.siteHeaderWrapperTransitioning).css("margin-top", "");
                                    }.bind(this)
                                );
                        }.bind(this)
                    ));
        },
        _closeAnnouncementBar: function (e) {
            if ((e.preventDefault(), !Shopify.designMode)) {
                var i = t(Qt.announcementBar);
                this.$siteHeaderWrapper.css("margin-top", "-" + i.outerHeight() + "px"),
                    t(Qt.announcementBarClose).attr("aria-expanded", !1),
                    B.isSessionStorageSupported() && sessionStorage.setItem("announcement-bar-hidden", !0),
                    B.promiseTransitionEnd(this.$siteHeaderWrapper).then(
                        function () {
                          i.remove(), this.$siteHeaderWrapper.removeClass(Kt.siteHeaderWrapperTransitioning).css("margin-top", "");
                          
                          // New Script
                          //console.log('disini');
                          var h = t('.site-header-sections').height();
                          t('.template-index #shopify-section-header').css('height', h);
                          // End Script
                        }.bind(this)
                    );
            }
        },
        _updateHeaderTransparency: function () {
            if ((!t("html").hasClass("is-ios") || !Shopify.designMode) && (this.$siteHeader.removeClass(Kt.headerTransparent), this.$siteHeader.data("transparent-header"))) {
                var e = t(Qt.contentForLayout).find("[data-section-type]").first();
                e.length && -1 !== Xt.indexOf(e.data("section-type")) && this.$siteHeader.addClass(Kt.headerTransparent);
            }
        },
        _toggleHeaderPosition: function () {
            if (Yt && !this.headerAnimating) {
                var e = t(document).scrollTop();
                (this.headerHeight = this.headerHeight || this.$container.outerHeight()),
                    e <= 0
                        ? requestAnimationFrame(this._promiseHeaderReset.bind(this))
                        : e < this.scrollTop && e > 0 && !this.isFixed && !this.isAnimating
                        ? requestAnimationFrame(this._promiseHeaderSlideIn.bind(this))
                        : e > this.scrollTop && e > this.headerHeight && this.isFixed && !this.isAnimating && requestAnimationFrame(this._promiseHeaderSlideOut.bind(this)),
                    (this.scrollTop = e),
                    this._doubleCheckPosition();
            }
        },
        _doubleCheckPosition: function () {
            void 0 === this.doubleCheckDebounced &&
                (this.doubleCheckDebounced = d(
                    function () {
                        (this.scrollTop = t(document).scrollTop()), this.scrollTop <= 0 && this._promiseHeaderReset();
                    }.bind(this),
                    500
                )),
                this.doubleCheckDebounced();
        },
        _promiseHeaderReset: function () {
            this.promiseChain = this.promiseChain.then(
                function () {
                    this.$container.removeClass(Kt.headerFixed), t("body").css("padding-top", "");
                }.bind(this)
            );
        },
        _promiseHeaderSlideIn: function () {
            return (
                (this.isFixed = !0),
                (this.headerAnimating = !0),
                this.$siteHeaderWrapper.css("transform", "translateY(-100%)"),
                requestAnimationFrame(
                    function () {
                        this.$container.addClass(Kt.headerFixed),
                            this.$container.hasClass(Kt.headerHomepage) || t("body").css("padding-top", this.headerHeight),
                            requestAnimationFrame(
                                function () {
                                    this.$siteHeaderWrapper.css({ transform: "translateY(0%)", transition: "transform 0.25s ease-out" });
                                }.bind(this)
                            );
                    }.bind(this)
                ),
                B.promiseTransitionEnd(this.$siteHeaderWrapper).then(
                    function () {
                        (this.headerAnimating = !1), this.$siteHeaderWrapper.attr("style", "");
                    }.bind(this)
                )
            );
        },
        _promiseHeaderSlideOut: function () {
            return (
                (this.isFixed = !1),
                (this.headerAnimating = !0),
                this.$siteHeaderWrapper.css({ transform: "translateY(-100%)", transition: "transform 0.25s ease-out" }),
                B.promiseTransitionEnd(this.$siteHeaderWrapper).then(
                    function () {
                        (this.headerAnimating = !1), this.$siteHeaderWrapper.attr("style", ""), t("body").css("padding-top", ""), this.$container.removeClass(Kt.headerFixed);
                    }.bind(this)
                )
            );
        },
        _toggleCartBubble: function (e, i) {
            var n = t(Qt.cartBubble, this.$container);
            n.toggleClass(Kt.cartBubbleVisible, 0 !== i.items.length),
                t("body").hasClass(Kt.drawerActive) ||
                    (n.addClass(Kt.bubblePulse),
                    B.promiseAnimationEnd(n).then(function () {
                        n.removeClass(Kt.bubblePulse);
                    }));
        },
        showNavigation: function () {
            var e = t(document.body).hasClass(Kt.navigationOpen);
            this.siteNavigation = this.container.querySelector(Qt.siteNavigation);
            var i = this.siteNavigation.querySelector(Qt.navigationButton);
            return (
                e ||
                    ((Yt = !1),
                    this._adjustNavigationPadding(),
                    s.trapFocus(this.siteNavigation, { elementToFocus: i }),
                    B.enableTabbingOfChildren(Qt.navigation),
                    t(Qt.navigation).attr("aria-hidden", !1),
                    (this.promiseChain = this.promiseChain
                        .then(this._promiseNavTransition.bind(this, !0))
                        .then(this._promiseNavItemsTransition.bind(this, t(Qt.navAnimateElements, this.$container).toArray(), !0))
                        .then(
                            function () {
                                t(document).on("keyup" + this.namespace, this._closeOnEscape.bind(this)), t(Qt.navigationButton).attr("aria-expanded", !0).off().one("click", this._toggleNavigationDisplay.bind(this));
                            }.bind(this)
                        ))),
                this.promiseChain.then(function () {
                    Shopify.designMode && t(document.body).addClass(Kt.navigationOpenEditor);
                })
            );
        },
        hideNavigation: function () {
            if (t(document.body).hasClass(Kt.navigationOpen)) {
                var e = t(Qt.navAnimateElements, this.$container);
                s.removeTrapFocus(),
                    B.disableTabbingOfChildren(Qt.navigation),
                    t(Qt.navigation).attr("aria-hidden", !0),
                    Shopify.designMode && (t(document.body).removeClass(Kt.navigationOpenEditor), e.addClass(Kt.navigationEntranceActive)),
                    (this.promiseChain = this.promiseChain
                        .then(this._promiseNavItemsTransition.bind(this, e.toArray().reverse(), !1))
                        .then(this._promiseNavTransition.bind(this, !1))
                        .then(
                            function () {
                                (Yt = !0), t(document).off("keyup" + this.namespace), t(Qt.navigationButton).off().one("click", this._toggleNavigationDisplay.bind(this)).attr("aria-expanded", !1).focus();
                            }.bind(this)
                        ));
            }
            return this.promiseChain;
        },
        _toggleNavigationDisplay: function () {
            (Jt = !0), t(document.body).hasClass(Kt.navigationOpen) ? this.hideNavigation() : this.showNavigation();
        },
        _adjustNavigationPadding: function () {
            (this.headerHeight = this.$siteHeader.height()),
                t(Qt.navigation, this.$container).css({ top: this.headerHeight + "px", "min-height": "calc(100vh - " + this.headerHeight + "px)", "max-height": "calc(100vh - " + this.headerHeight + "px)" });
        },
        _promiseNavTransition: function (e) {
            return (
                t(document.body).addClass(Kt.navigationTransitioning).toggleClass(Kt.navigationOpen, e),
                t(window).scrollTop(this.scrollTop),
                B.promiseTransitionEnd(t(Qt.navigation, this.$container)).then(function () {
                    t(document.body).removeClass(Kt.navigationTransitioning);
                })
            );
        },
        _promiseNavItemsTransition: function (e, i) {
            return B.mapPromiseSeries(e, function (e, n) {
                var s = t(n);
                return s.toggleClass(Kt.navigationEntranceActive, i), B.promiseTransitionEnd(s);
            });
        },
        _closeOnEscape: function (t) {
            27 === t.keyCode && this.hideNavigation();
        },
        _toggleNavigationSublinks: function (e) {
            var i = t(e.currentTarget),
                n = i.parent(),
                s = "true" === i.attr("aria-expanded"),
                o = n.find(Qt.navigationExpandChildSublinks);
            n.toggleClass(Kt.navigationHasSublinksCollapsed),
                n.siblings(Qt.navigationHasSublinks).addClass(Kt.navigationHasSublinksCollapsed).children(Qt.navigationExpandSublinks).attr("aria-expanded", !1),
                this._setMaxHeight(n.siblings(Qt.navigationHasSublinks), ""),
                o.length && this._updateSublinkMaxHeight(i),
                i.attr("aria-expanded", !s),
                this._toggleSubNavigationElementHeight(i);
        },
        _updateSublinkMaxHeight: function (e) {
            if (e.hasClass(Kt.navigationExpandChildSublinks)) {
                var i = e.closest(Qt.navigationSublinksContainer),
                    n = i.find(Qt.navigationHasSublinks),
                    s = i.data("max-height");
                n.each(function () {
                    var e = t(this);
                    if (!e.hasClass(Kt.navigationHasSublinksCollapsed)) {
                        var i = e.find(Qt.navigationChildSublinks),
                            n = i.parent();
                        s += n.data("max-height");
                    }
                }),
                    i.css("max-height", s);
            }
        },
        _setSublinksMaxHeight: function () {
            t(Qt.navigationSublinks, this.$container).each(function () {
                var e = t(this),
                    i = e.parent(),
                    n = e.outerHeight();
                i.data("max-height", n).css("max-height", n);
            });
        },
        _toggleSubNavigationElementHeight: function (t) {
            var e = t.parent("li");
            if (e.hasClass(Kt.navigationHasSublinksCollapsed)) this._setMaxHeight(e, "");
            else {
                if (e.hasClass(Qt.navigationSublink)) return void this._updateSublinkMaxHeight(e);
                this._setMaxHeight(e, "none");
            }
        },
        _setMaxHeight: function (t, e) {
            t.css("max-height", e);
        },
    }),
        z.register("list-collections-template", {
            onLoad: function () {
                this.extend(X);
            },
        });
    var Zt,
        te = {
            zeroResults: theme.strings.map && theme.strings.map.zeroResults,
            overQueryLimit: theme.strings.map && theme.strings.map.overQueryLimit,
            authError: theme.strings.map && theme.strings.map.authError,
            requestDenied: theme.strings.map && theme.strings.map.addressError,
            geocodeUnknownError: theme.strings.map && theme.strings.map.addressError,
            missingKey: theme.strings.map && theme.strings.map.addressError,
            apiLoadError: theme.strings.map && theme.strings.map.authError,
        },
        ee = {
            promiseAPI: function (e) {
                return (
                    (e = e || ""),
                    void 0 === Zt && (Zt = t.getScript("https://maps.googleapis.com/maps/api/js?key=" + e)),
                    Zt.then(function () {
                        return t.Deferred(function (t) {
                            (window.google && window.google.maps) || t.reject(te.apiLoadError), t.resolve(window.google);
                        });
                    })
                );
            },
            promiseGeocode: function (e) {
                return this.promiseAPI().then(function (i) {
                    return t.Deferred(function (t) {
                        var n;
                        (window.gm_authFailure = function () {
                            t.reject(te.authError);
                        }),
                            (n = new i.maps.Geocoder()),
                            n.geocode({ address: e }, function (e, n) {
                                n !== i.maps.GeocoderStatus.OK && t.reject(T(n)), t.resolve(e);
                            });
                    });
                });
            },
            promiseMap: function (e) {
                return t.when(this.promiseAPI(e.key), this.promiseGeocode(e.address)).then(function (i, n) {
                    return t.Deferred(function (s) {
                        var o,
                            a = n[0].geometry.location,
                            r = t.extend({}, { zoom: 14, center: a, disableDefaultUI: !0 }, e);
                        return (
                            (window.gm_authFailure = function () {
                                s.reject(te.authError);
                            }),
                            (o = new i.maps.Map(e.container, r)),
                            (o.centerMarker = new i.maps.Marker({ map: o, position: o.getCenter() })),
                            i.maps.event.addDomListener(
                                window,
                                "resize",
                                d(function () {
                                    i.maps.event.trigger(o, "resize"), o.setCenter(a);
                                }, 250)
                            ),
                            s.resolve(o)
                        );
                    });
                });
            },
        },
        ie = { map: ".map-section__container", mapError: ".map-section__error-message" },
        ne = { mapError: "map-section--load-error" };
    z.register("map", {
        onLoad: function () {
            if (((this.$container = t(this.container)), (this.$map = t(ie.map, this.$container)), (this.key = this.$map.data("api-key")), "string" == typeof this.key && "" !== this.key)) {
                var e = { key: this.key, container: this.$map[0], address: this.$map.data("address-setting") };
                B.promiseStylesheet()
                    .then(function () {
                        return ee.promiseMap(e);
                    })
                    .then(
                        function (t) {
                            this.map = t;
                        }.bind(this)
                    )
                    .catch(
                        function (e) {
                            this.$container.addClass(ne.mapError), Shopify.designMode && t(ie.mapError, this.$container).html(e).css("display", "inline-block");
                        }.bind(this)
                    );
            }
        },
    });
    var se = { emailField: "#EmailField", inputGroup: ".input-group--underline", submitButton: ".btn--newsletter__submit", newsletterMessage: ".newsletter__message" },
        oe = { blankError: theme.strings.newsletter && theme.strings.newsletter.blankError, invalidError: theme.strings.newsletter && theme.strings.newsletter.invalidError };
    z.register("newsletter", {
        onLoad: function () {
            t("html").hasClass("is-ios") && Shopify.designMode && t(se.inputGroup, this.$container).addClass("has-animated"), this.$container.on("click", se.submitButton, this._checkEmail.bind(this));
        },
        _checkEmail: function () {
            var e,
                i = se.emailField + this.$container.data("section-id"),
                n = t(i, this.$container),
                s = t(se.newsletterMessage, this.$container),
                o = n[0].value,
                a = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (("" === o ? (e = oe.blankError) : a.test(o) || (e = oe.invalidError), void 0 !== e)) return s.html('<p class="errors">' + e + "</p>"), !1;
            s.html("");
        },
    });
    var ae = {
            productRecommendationSlider: "[data-recommendations-slider]",
            productRecommendationSlides: "[data-recommendations-slide]",
            indicatorsWrapper: "[data-recommendations-indicators]",
            indicator: "[data-recommendations-indicator]",
            productRecommendationIndicatorIndex: function (t) {
                return '[data-product-recommendation-indicator-index="' + t + '"]';
            },
        },
        re = { indicatorActive: "product-recommendations__slide-indicator--active" };
    z.register("product-recommendations", {
        onLoad: function () {
            this.didShowRecommendations = !1;
            var e = this.$container.data("baseUrl"),
                i = this.$container.data("productId"),
                n = e + "?section_id=product-recommendations&product_id=" + i + "&limit=4";
            B.promiseStylesheet()
                .then(function () {
                    return t.get(n);
                })
                .then(
                    function (e) {
                        var i = t(e).html();
                        "" !== i.trim() && (this.$container.html(i), this._initProductRecommendations(), (this.didShowRecommendations = !0));
                    }.bind(this)
                );
        },
        _initProductRecommendations: function () {
            (this.eventHandlers = {}), (this.mql = window.matchMedia("(max-width: 749px)")), this._setupEventHandlers(), this._mediaQueryHandler();
        },
        _setupEventHandlers: function () {
            (this.eventHandlers._mediaQueryHandler = this._mediaQueryHandler.bind(this)),
                (this.eventHandlers._updateIndicatorActiveState = this._updateIndicatorActiveState.bind(this)),
                this.mql.addListener(this.eventHandlers._mediaQueryHandler);
        },
        _mediaQueryHandler: function () {
            this.mql.matches ? this._initializeMobileSlider() : this._destroyMobileSlider();
        },
        _initializeMobileSlider: function () {
            (this.$slider = this.$slider || this.$container.find(ae.productRecommendationSlider)),
                (this.$slides = this.$slides || this.$slider.find(ae.productRecommendationSlides)),
                this.$slides.length < 2 ||
                    ((this.$indicatorsWrapper = this.$indicatorsWrapper || this.$container.find(ae.indicatorsWrapper)),
                    (this.$indicators = this.$indicators || this.$indicatorsWrapper.find(ae.indicator)),
                    this.$slider.on("scroll", { passive: !0 }, this.eventHandlers._updateIndicatorActiveState),
                    this._updateIndicatorActiveState());
        },
        _destroyMobileSlider: function () {
            this.$slider && this.$slider.off("scroll");
        },
        _updateIndicatorActiveState: function () {
            this.$indicators.removeClass(re.indicatorActive);
            var t = this.$slider.scrollLeft(),
                e = this.$slides.length,
                i = this.$slider[0].scrollWidth / e,
                n = Math.round(t / i) + 1;
            this.$container.find(ae.productRecommendationIndicatorIndex(n)).addClass(re.indicatorActive);
        },
        onUnload: function () {
            this.didShowRecommendations && (this.mql.removeListener(this.eventHandlers._mediaQueryHandler), this._destroyMobileSlider());
        },
    });
    var de = { lazypreload: "lazypreload", showProductSlideshow: "product-slideshow--show", productSlideshowSelectActive: "product-slideshow__slide-select--active" },
        le = {
            slider: "[data-product-slider]",
            productSlideshow: "[data-product-slideshow]",
            productSlideshowOpen: "[data-product-slideshow-open]",
            productSlideshowSlide: "[data-product-slideshow-slide]",
            productSlideshowImage: "[data-product-slideshow-image]",
            productSlideshowNext: "[data-product-slideshow-next]",
            productSlideshowSelect: "[data-product-slideshow-select]",
            productSlideshowPrevious: "[data-product-slideshow-previous]",
            productSlideshowClose: "[data-product-slideshow-close]",
            productMediaTypeVideo: "[data-product-media-type-video]",
            plyrAspectRatio: "[data-plyr-aspect-ratio]",
        },
        he = { productMediaTypeModel: "data-product-media-type-model" },
        ce = {
            init: function () {
                (this.$productSlideshow = t(le.productSlideshow, this.$container)),
                    (this.$slideshowSelect = t(le.productSlideshowSelect)),
                    (this.translateDistance = 0),
                    (this.dotSettings = { maxVisibleDots: 9, dotWidth: 16 }),
                    this.extend(Tt),
                    this.extend(Mt),
                    this.initModelViewers(this.$productSlideshow),
                    this.initProductVideos(this.$productSlideshow),
                    t(window).on(
                        "resize",
                        d(
                            function () {
                                this.adjustPlyrMaxWidth();
                            }.bind(this),
                            100
                        )
                    ),
                    0 !== this.$productSlideshow.length &&
                        (t(le.productSlideshowOpen).on("click", this._onImageClick.bind(this)),
                        this.$productSlideshow.appendTo(document.body),
                        (this.slideCount = t(le.productSlideshowSlide, this.$productSlideshow).length),
                        this.slideCount &&
                            ((this.slider = new x(t(le.slider, this.$productSlideshow))),
                            this.slider.$slides.on(
                                "mediaSlideIsDraggable",
                                function (t, e) {
                                    this.slider.setIsDraggable(e);
                                }.bind(this)
                            )));
            },
            showSlideshow: function () {
                return (
                    this.trigger("product_slideshow_show"),
                    (this.$slideshowOpenFocus = t(document.activeElement)),
                    t(le.productSlideshowImage, this.$productSlideshow).addClass(de.lazypreload),
                    z.getInstances("header-section").then(
                        function (t) {
                            (t[0].scrollHandler = !1),
                                this._assignEventHandlers(),
                                q.trapFocus({ $container: this.$productSlideshow, namespace: "product-slideshow" }),
                                this.$productSlideshow.addClass(de.showProductSlideshow).attr("aria-hidden", !1),
                                this.adjustPlyrMaxWidth(),
                                B.disableScrollBody(),
                                B.enableTabbingOfChildren(this.$productSlideshow);
                        }.bind(this)
                    )
                );
            },
            hideSlideshow: function () {
                return (
                    this.trigger("product_slideshow_hide"),
                    z.getInstances("header-section").then(
                        function (t) {
                            (t[0].scrollHandler = !0),
                                this._removeEventHandlers(),
                                q.removeTrapFocus({ namespace: "product-slideshow" }),
                                B.enableScrollBody(),
                                B.disableTabbingOfChildren(this.$productSlideshow),
                                this.$productSlideshow.removeClass(de.showProductSlideshow).attr("aria-hidden", !0),
                                this.$slideshowOpenFocus.focus(),
                                this.slider.$currentSlide.trigger("mediaHidden"),
                                this.updateShopifyXr();
                        }.bind(this)
                    )
                );
            },
            setSlide: function (t) {
                if (!(this.slideCount <= 1)) {
                    var e = this._getSlideIndex(t);
                    return this.trigger("product_slideshow_set_slide", [e]), this.slider.setSlide(e);
                }
            },
            adjustPlyrMaxWidth: function () {
                t(le.plyrAspectRatio).each(function () {
                    var e = t(this),
                        i = parseFloat(e.data("plyr-aspect-ratio")),
                        n = t(e.closest(le.productMediaTypeVideo)).height(),
                        s = n * i;
                    e.css("max-width", s + "px");
                });
            },
            _onImageClick: function (e) {
                e.preventDefault();
                var i = t(e.currentTarget).data("media-id");
                this.setSlide(i), this.showSlideshow(), this._triggerMediaVisible(i);
            },
            _triggerMediaVisible: function (e) {
                var i = t(le.productSlideshowSlide, this.$productSlideshow).filter('[data-media-id="' + e + '"]');
                i && i.trigger("mediaVisible");
            },
            _assignEventHandlers: function () {
                t(document).one("keyup.product-slideshow", this._onKeyup.bind(this)),
                    this.$productSlideshow
                        .on(
                            "slidetransitionend",
                            function (e, i) {
                                this._setSlideIndicator(e, i);
                                var n = i.$currentSlide.data("media-id");
                                t(this.slider.$slides)
                                    .filter(":not([data-media-id='" + n + "'])")
                                    .trigger("mediaHidden");
                                var s = i.$currentSlide[0].hasAttribute(he.productMediaTypeModel);
                                s && B.isTouch() ? (this.updateShopifyXr(this.id, n), this.slider.setIsDraggable(!0)) : s ? this.updateShopifyXr(this.id, n) : (this.updateShopifyXr(this.id), this.slider.setIsDraggable(!0));
                            }.bind(this)
                        )
                        .on("click", le.productSlideshowSelect, this._setSlide.bind(this))
                        .on("keyup", le.productSlideshowSelect, this._handleMediaFocus.bind(this))
                        .one("click", le.productSlideshowClose, this.hideSlideshow.bind(this))
                        .one("click", le.productSlideshowNext, this._nextSlide.bind(this))
                        .one("click", le.productSlideshowPrevious, this._previousSlide.bind(this));
            },
            _removeEventHandlers: function () {
                this.$productSlideshow.off(), t(document).off(".product-slideshow");
            },
            _getSlideIndex: function (e) {
                return t(le.productSlideshowSlide, this.$productSlideshow)
                    .filter('[data-media-id="' + e + '"]')
                    .index();
            },
            _handleMediaFocus: function (e) {
                if (e.keyCode === B.keyboardKeys.ENTER || e.keyCode === B.keyboardKeys.SPACE) {
                    var i = t(e.currentTarget).index(),
                        n = t(this.slider.$slides[i]),
                        s = n.find("model-viewer, .plyr");
                    s.length ? s.first().focus() : n.focus();
                }
            },
            _setSlide: function (e) {
                var i = t(e.target),
                    n = i.index();
                this.trigger("product_slideshow_set_slide", [n]), this.slider.setSlide(n);
            },
            _nextSlide: function () {
                return (
                    this.trigger("product_slideshow_next"),
                    this.trigger("product_slideshow_set_slide", [this.slider.$nextSlide.index()]),
                    this.slider.nextSlide().then(
                        function () {
                            this.$productSlideshow.one("click", le.productSlideshowNext, this._nextSlide.bind(this));
                        }.bind(this)
                    )
                );
            },
            _previousSlide: function () {
                return (
                    this.trigger("product_slideshow_previous"),
                    this.trigger("product_slideshow_set_slide", [this.slider.$previousSlide.index()]),
                    this.slider.previousSlide().then(
                        function () {
                            this.$productSlideshow.one("click", le.productSlideshowPrevious, this._previousSlide.bind(this));
                        }.bind(this)
                    )
                );
            },
            _setSlideIndicator: function (e, i) {
                var n = i.$currentSlide.index();
                t(le.productSlideshowSelect, this.$productSlideshow).eq(n).addClass(de.productSlideshowSelectActive).siblings().removeClass(de.productSlideshowSelectActive), this.translateDots(n);
            },
            translateDots: function (t) {
                var e = this.dotSettings;
                if (!(this.slideCount <= e.maxVisibleDots)) {
                    var i = (this.slideCount - e.maxVisibleDots) * e.dotWidth;
                    if (t >= e.maxVisibleDots - 1) {
                        var n = (t + 2 - e.maxVisibleDots) * e.dotWidth;
                        (n = i < n ? i : n), (this.translateDistance = -n);
                    } else this.translateDistance = 0;
                    this.$slideshowSelect.css("transform", "translateX(" + this.translateDistance + "px)");
                }
            },
            _onKeyup: function (e) {
                var i = t.Deferred().resolve(),
                    n = this.slider.shouldPreventSlide(e.target, [".plyr", ".shopify-model-viewer-ui"], this.slideCount);
                switch (e.keyCode) {
                    case 37:
                        if (n) break;
                        i = this.slider.previousSlide();
                        break;
                    case 39:
                        if (n) break;
                        i = this.slider.nextSlide();
                        break;
                    case 27:
                        this.hideSlideshow(), (i = t.Deferred().reject());
                }
                i.then(
                    function () {
                        t(document).one("keyup", this._onKeyup.bind(this));
                    }.bind(this)
                );
            },
        },
        ue = { productFormWrapper: ".product__form-wrapper", productDescription: ".product__description" },
        pe = { productFormFixed: "product__form-wrapper--fixed", productFormBottom: "product__form-wrapper--bottom" };
    z.register("product-template", {
        onLoad: function () {
            (this.coverPosition = "top"),
                this.extend(ce),
                this.extend(F),
                this.extend(ft),
                this.window().on("scroll", this._setFormPosition.bind(this)),
                this.window().on("resize", d(this._callResizeFunctions.bind(this), 500)),
                this.on("variant_add_to_cart", this._updateMeasurements.bind(this)),
                this.on("variant_change", this._updateHistoryState.bind(this)),
                this.document().on("drawer_open_start", this._handleFixedSideImage.bind(this)),
                this.document().on("drawer_close_done", this._resetFixedSideImage.bind(this)),
                B.promiseStylesheet().then(
                    function () {
                        this._updateMeasurements();
                    }.bind(this)
                );
        },
        _callResizeFunctions: function () {
            this._updateMeasurements(), this._formatVariantSelectors();
        },
        _handleFixedSideImage: function () {
            if ("fixed" === this.coverPosition) {
                var e = t(window).scrollTop(),
                    i = e - this.fixedTop + 160 + 28;
                t(ue.productFormWrapper, this.$container).css({ transform: "translateY(" + i + "px)", position: "absolute" });
            }
        },
        _resetFixedSideImage: function () {
            "fixed" === this.coverPosition && t(ue.productFormWrapper, this.$container).css({ transform: "", position: "" });
        },
        _updateHistoryState: function (t, e, i, n) {
            if (history.replaceState) {
                var s = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + n.id;
                window.history.replaceState({ path: s }, "", s);
            }
        },
        _setFormPosition: function () {
            if (!B.isMobile() && this.enableSticky) {
                var e = t(window).scrollTop();
                requestAnimationFrame(
                    function () {
                        e > this.fixedTop
                            ? e > this.fixedBottom
                                ? ((this.coverPosition = "bottom"), t(ue.productFormWrapper).css("width", this.formWidth).removeClass(pe.productFormFixed).addClass(pe.productFormBottom))
                                : ((this.coverPosition = "fixed"), t(ue.productFormWrapper).css("width", this.formWidth).addClass(pe.productFormFixed).removeClass(pe.productFormBottom))
                            : ((this.coverPosition = "top"), t(ue.productFormWrapper).css("width", "").removeClass(pe.productFormFixed).removeClass(pe.productFormBottom));
                    }.bind(this)
                );
            }
        },
        _updateMeasurements: function () {
            var e = t(ue.productFormWrapper),
                i = t(ue.productDescription).outerHeight(!0),
                n = e.height();
            (this.enableSticky = i > n), this.enableSticky && ((this.fixedTop = e.parent().offset().top - 80), (this.fixedBottom = this.fixedTop + i - n), (this.formWidth = e.parent().width()), this._setFormPosition());
        },
    });
    var me = { slider: ".quotes-slider", slide: ".quotes-slide" },
        fe = { visible: "quotes-slide--visible" };
    z.register("quotes-section", {
        onLoad: function () {
            (this.$container = t(this.container)),
                (this.$slider = t(me.slider, this.$container)),
                (this.totalSlides = this.$slider.data("count")),
                (this.speed = this.$slider.data("speed")),
                (this.currentSlide = 0),
                this.$slider.find(me.slide).length > 1 && this._startSlider();
        },
        _startSlider: function () {
            this.interval = setInterval(
                function () {
                    this.currentSlide + 1 >= this.totalSlides ? (this.currentSlide = 0) : this.currentSlide++, this._showSlide(me.slide + "--" + this.currentSlide);
                }.bind(this),
                this.speed
            );
        },
        _showSlide: function (t) {
            this.$slider.find(me.slide).removeClass(fe.visible).end().find(t).addClass(fe.visible);
        },
        onBlockSelect: function (t) {
            clearInterval(this.interval);
            var e = this.$container.find(me.slide + "--" + t.detail.blockId);
            this._showSlide(e);
        },
        onBlockDeselect: function () {
            this._startSlider();
        },
    }),
        z.register("search-template", {
            onLoad: function () {
                this.extend(X);
            },
        });
    var ge,
        ve = {
            promiseAPI: function () {
                return (
                    ge ||
                        (ge = t.Deferred(function (t) {
                            var e = document.createElement("script");
                            (e.src = "https://player.vimeo.com/api/player.js"),
                                (e.onload = e.onreadystatechange = function () {
                                    (this.readyState && "complete" !== this.readyState) || t.resolve();
                                });
                            var i = document.getElementsByTagName("script")[0];
                            i.parentNode.insertBefore(e, i),
                                setTimeout(function () {
                                    t.reject("Request for Vimeo API timed out after 30 seconds.");
                                }, 3e4);
                        })),
                    ge
                );
            },
            promisePlayer: function (e, i) {
                return this.promiseAPI().then(function () {
                    return t.Deferred(function (t) {
                        void 0 === window.Vimeo && t.reject("We're sorry, something went wrong. The Vimeo API has not loaded correctly.");
                        var n = new window.Vimeo.Player(e, i);
                        setTimeout(function () {
                            t.reject("Request for Vimeo player has timed out after 30 seconds.");
                        }, 3e4),
                            n.ready().then(function () {
                                t.resolve(n);
                            });
                    });
                });
            },
        },
        _e = {
            buttons: ".slideshow__buttons",
            button: ".slideshow__button",
            pauseButton: "[data-pause-button]",
            label: ".slideshow__button-label",
            cta: ".slideshow__button-cta--desktop",
            ctaText: ".slideshow__heading-cta-text",
            slide: ".slideshow__slide",
            slideshow: ".slideshow",
            video: ".slideshow__video",
        },
        be = {
            centredCta: "slideshow--center-cta",
            buttonActive: "slideshow__button--active",
            headingCtaActive: "slideshow__heading-cta-text--active",
            headingCtaTransitioning: "slideshow__heading-cta-text--transitioning",
            linkActive: "slideshow__button--link",
            slideActive: "slideshow__slide--active",
            slideActiveTransitioning: "slideshow__slide--transitioning",
            videoLoaded: "slideshow__video--loaded",
            videoPaused: "slideshow__video--paused",
            paused: "is-paused",
        },
        Se = { easeIntensity: 10 },
        ye = {
            initDesktopSlideshow: function () {
                this.trigger("slideshow_desktop_init_start"),
                    (this.$slideshow = t(_e.slideshow, this.$container)),
                    (this.$slide = t(_e.slide, this.$container)),
                    (this.$buttons = t(_e.buttons, this.$container)),
                    (this.$button = t(_e.button, this.$container)),
                    (this.desktopSlideshow = !0),
                    (this.isAnimating = !1),
                    (this.currentDesktopSlide = 0),
                    (this.totalSlides = this.$buttons.data("count")),
                    (this.players = []),
                    (this.desktopSlideshowNamespace = ".desktopSlideshow"),
                    (this.isPostInitialized = !1),
                    this.on("mouseover" + this.desktopSlideshowNamespace, this._onHoverSlideshow.bind(this)),
                    this.on("mousemove" + this.desktopSlideshowNamespace, this._mouseMoveButtons.bind(this)),
                    this.on("mouseleave" + this.desktopSlideshowNamespace, this._resetButtonsPosition.bind(this)),
                    this.on("keydown" + this.desktopSlideshowNamespace, this._onTabButtons.bind(this)),
                    this.on("click" + this.desktopSlideshowNamespace, _e.pauseButton, this._onPauseButton.bind(this)),
                    this.on("click" + this.desktopSlideshowNamespace, _e.label, this._onClickButton.bind(this)),
                    this.on("keydown" + this.desktopSlideshowNamespace, this._addKeyBindingsDesktop.bind(this)),
                    this.window().on("resize" + this.desktopSlideshowNamespace, this._setButtonWrapperValues.bind(this)),
                    B.promiseStylesheet().then(
                        function () {
                            this._setButtonWrapperValues(), this._setSlideDesktop(0), this.$container.hasClass(be.centredCta) && this._setButtonStatus(0), this.trigger("slideshow_desktop_init_done");
                        }.bind(this)
                    );
            },
            destroyDesktopSlideshow: function () {
                this.trigger("slideshow_desktop_destroy"), (this.desktopSlideshow = !1), this.off(this.desktopSlideshowNamespace), this.window().off(this.desktopSlideshowNamespace), this._setButtonsTranslateX(0);
                for (var t in this.players) {
                    if (!this.players.hasOwnProperty(t)) return;
                    var e = this.players[t];
                    "function" == typeof e.destroy ? e.destroy() : "function" == typeof e.unload && e.unload();
                }
                this.players = [];
            },
            _onHoverSlideshow: function () {
                this._animateButtonFrame();
            },
            _mouseMoveButtons: function (t) {
                this.totalSlides <= 3 || ((this.mousePosition = t.pageX - this.centerOfButtonsWrapper), this.isAnimating || ((this.isAnimating = !0), this._animateButtonFrame()));
            },
            _resetButtonsPosition: function () {
                this.mousePosition = 0;
            },
            _onTabButtons: function (e) {
                if (e.which === B.keyboardKeys.TAB) {
                    var i;
                    if (((i = e.shiftKey ? t(e.target).closest(this.$button).prev() : t(e.target).closest(this.$button).next()), i.length)) {
                        var n = t(window).width() / this.totalSlides,
                            s = i.index();
                        (this.mousePosition = n * s - i.width()), this._animateButtonFrame();
                    }
                }
            },
            _onPauseButton: function (e) {
                var i = this.$slide.eq(this.currentDesktopSlide),
                    n = t(e.target),
                    s = n.hasClass(be.paused),
                    o = this.$video.attr("data-block-id");
                n.toggleClass(be.paused, !s).attr({ "aria-label": s ? n.data("label-pause") : n.data("label-play"), "aria-pressed": !s }),
                    this.players[o] && (s ? this.players[o].playVideo() : this.players[o].pauseVideo()),
                    i.toggleClass(be.videoPaused);
            },
            _onClickButton: function (e) {
                var i = t(e.target).closest(_e.button);
                //if (!i.hasClass(be.buttonActive)) {
                    var n = i.index();
                    this._setSlideDesktop(n), i.hasClass(be.buttonActive) || this._setButtonStatus(n);
                //}
            },
            _setButtonStatus: function (t) {
                var e = this.$button.eq(t),
                    i = e.find(_e.ctaText);
                this.$button.removeClass(be.buttonActive).find(_e.label).attr("aria-expanded", !1),
                    e.addClass(be.buttonActive).find(_e.label).attr("aria-expanded", !0),
                    this.isPostInitialized ? e.focus() : (this.isPostInitialized = !0),
                    this.$buttons.find(_e.ctaText).empty().attr("aria-hidden", !0).removeClass(be.headingCtaActive).removeAttr("style"),
                    i.parent().is("a") && this._showButtonContent(i),
                    this.$button.find(_e.cta).attr("tabindex", "-1"),
                    e.hasClass(be.linkActive) && e.find(_e.cta).attr("tabindex", "0");
            },
            _animateButtonFrame: function () {
                var t = this.mousePosition - this.xPosition,
                    e = this.buttonsInnerWidth / this.buttonsWrapperWidth - 1;
                if (Math.abs(t) < 1) return void (this.isAnimating = !1);
                (this.xPosition += t / Se.easeIntensity), this._setButtonsTranslateX(-this.xPosition * e), requestAnimationFrame(this._animateButtonFrame.bind(this));
            },
            _showButtonContent: function (t) {
                var e = t.data("button-text");
                t.html(e).attr("aria-hidden", !1), (t.attr("data-new-width") && t.attr("data-new-height")) || (t.attr("data-new-width", t.outerWidth()), t.attr("data-new-height", t.outerHeight()));
                var i = t.attr("data-new-width"),
                    n = t.attr("data-new-height");
                t.empty(),
                    requestAnimationFrame(function () {
                        t.css({ minHeight: n + "px", minWidth: i + "px" }).addClass(be.headingCtaTransitioning);
                    }),
                    B.promiseTransitionEnd(t).then(function () {
                        t.html(e).removeClass(be.headingCtaTransitioning).addClass(be.headingCtaActive);
                    });
            },
            _setButtonsTranslateX: function (t) {
                this.$buttons.css({ transform: "translate3d(" + t + "px, 0, 0)" });
            },
            _addKeyBindingsDesktop: function (t) {
                t.which === B.keyboardKeys.LEFTARROW ? this._previousSlideDesktop() : t.which === B.keyboardKeys.RIGHTARROW && this._nextSlideDesktop();
            },
            _previousSlideDesktop: function () {
                0 !== this.currentDesktopSlide && this._setSlideDesktop(this.currentDesktopSlide - 1);
            },
            _nextSlideDesktop: function () {
                this.currentDesktopSlide !== this.totalSlides - 1 && this._setSlideDesktop(this.currentDesktopSlide + 1);
            },
            _setSlideDesktop: function (t) {
                var e = this.$slide.eq(this.currentDesktopSlide),
                    i = this.$slide.eq(t),
                    n = i.find(_e.video);
                n.length && this._loadVideo(n, i),
                    this.currentDesktopSlide !== t &&
                        (i.addClass(be.slideActive).attr("aria-hidden", !1),
                        e.addClass(be.slideActiveTransitioning),
                        B.promiseTransitionEnd(i).then(function () {
                            e.removeClass(be.slideActive).removeClass(be.slideActiveTransitioning).attr("aria-hidden", !0);
                        }),
                        this._setButtonStatus(t),
                        (this.currentDesktopSlide = t),
                        this.trigger("slideshow_set_slide", [t]),
                        this.currentDesktopSlide - 1 >= 0 && this.trigger("slideshow_previous_slide", [t - 1]),
                        this.currentDesktopSlide + 1 < this.totalSlides && this.trigger("slideshow_next_slide", [t + 1]));
            },
            _loadVideo: function (t, e) {
                return (
                    (this.$video = t),
                    this.trigger("slideshow_video_load", [t[0]]),
                    this._promiseVideo().then(
                        function () {
                            e.addClass(be.videoLoaded), e.find(_e.pauseButton).prop("disabled", !1), this.trigger("slideshow_video_loaded", [t[0]]);
                        }.bind(this)
                    )
                );
            },
            _promiseVideo: function () {
                var t,
                    e = this.$video.attr("data-video-type");
                return "youtube" === e ? ((t = this._loadYoutubePlayer()), this.$video.attr("tabindex", "-1")) : "vimeo" === e && ((t = this._loadVimeoPlayer()), this.$video.find("iframe").attr("tabindex", "-1")), t;
            },
            _loadYoutubePlayer: function () {
                var e = this.$video.attr("data-block-id"),
                    i = this.$video.attr("data-video-id");
                return Pt.promisePlayer(this.$video[0], {
                    videoId: i,
                    ratio: 16 / 9,
                    playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, controls: 0, showinfo: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
                    events: {
                        onStateChange: function (t) {
                            0 === t.data && this.players[e].seekTo(0);
                        }.bind(this),
                    },
                }).then(
                    function (i) {
                        return (
                            (this.players[e] = i),
                            i.playVideo().mute(),
                            t(i.a).css("visibility", "visible"),
                            t.Deferred(function (t) {
                                i.addEventListener("onStateChange", function (e) {
                                    1 === e.data && t.resolve();
                                });
                            })
                        );
                    }.bind(this)
                );
            },
            _loadVimeoPlayer: function () {
                var e = this.$video.attr("data-block-id"),
                    i = this.$video.attr("data-video-id");
                return ve.promisePlayer(this.$video[0], { id: i, loop: !0, playbar: !1, background: !0 }).then(
                    function (i) {
                        return (
                            (this.players[e] = i),
                            i.play(),
                            i.setVolume(0),
                            t.Deferred(function (t) {
                                i.on("loaded", function () {
                                    t.resolve();
                                });
                            })
                        );
                    }.bind(this)
                );
            },
            _setButtonWrapperValues: function () {
                (this.mousePosition = 0),
                    (this.xPosition = 0),
                    (this.buttonsWrapperWidth = this.$container.outerWidth()),
                    (this.buttonsInnerWidth = this.$button.first().width() * this.totalSlides),
                    (this.centerOfButtonsWrapper = this.buttonsWrapperWidth / 2),
                    this.$button.find(_e.ctaText).removeAttr("style data-previous-width data-previous-height data-new-width data-new-height"),
                    this._setButtonsTranslateX(0);
            },
        },
        we = {
            button: ".slideshow__button",
            buttons: ".slideshow__buttons",
            ctaMultipleSlides: ".slideshow__button-cta--multiple",
            ctaSingleSlide: ".slideshow__button-cta-single",
            label: ".slideshow__button-label",
            mobileTextContainer: ".slideshow__text-container-mobile",
            mobileTextContent: ".slideshow__text-content-mobile",
            navigationButtons: "[data-slider-navigation]",
            nextButton: "[data-slider-navigation-next]",
            previousButton: "[data-slider-navigation-previous]",
            slide: ".slideshow__slide",
            slideshow: ".slideshow",
            indicatorDots: ".slideshow__indicator",
        },
        Ce = {
            buttonActive: "slideshow__button--active",
            dotActive: "slideshow__indicator--active",
            linkActive: "slideshow__button--link",
            slideActive: "slideshow__slide--active",
            slideActiveTransitioning: "slideshow__slide--transitioning",
            navigationNoFocus: "slideshow__navigation-item--no-focus",
        },
        $e = {
            initMobileSlideshow: function () {
                this.trigger("slideshow_mobile_init_start"),
                    (this.$slideshow = t(we.slideshow, this.$container)),
                    (this.$buttons = t(we.buttons, this.$container)),
                    (this.$button = t(we.button, this.$container)),
                    (this.$navigationButtons = t(we.navigationButtons, this.$container)),
                    (this.$ctaMultipleSlides = t(we.ctaMultipleSlides, this.$container)),
                    (this.$ctaSingleSlide = t(we.ctaSingleSlide, this.$container)),
                    (this.$indicatorDots = t(we.indicatorDots, this.$container)),
                    (this.$mobileTextContainer = t(we.mobileTextContainer, this.$container)),
                    (this.$mobileTextContent = t(we.mobileTextContent, this.$container)),
                    (this.mobileSlideshow = !0),
                    (this.currentMobileSlide = 0),
                    (this.totalSlides = this.$buttons.data("count")),
                    (this.xPosition = 0),
                    (this.mobileSlideshowNamespace = ".mobileSlideshow"),
                    t("html").hasClass("is-ios") && Shopify.designMode && this.$slideshow.css("height", "-=60px"),
                    this.on("click keyup" + this.mobileSlideshowNamespace, we.indicatorDots, this._onClickIndicatorDot.bind(this)),
                    this.on("click keyup" + this.mobileSlideshowNamespace, we.previousButton, this._previousSlideMobile.bind(this)),
                    this.on("click keyup" + this.mobileSlideshowNamespace, we.nextButton, this._nextSlideMobile.bind(this)),
                    this.on("keydown" + this.mobileSlideshowNamespace, this._addKeyBindingsMobile.bind(this)),
                    this.totalSlides > 1 && ((this.hammertime = new p(this.$container[0])), this.hammertime.on("swipeleft", this._nextSlideMobile.bind(this)).on("swiperight", this._previousSlideMobile.bind(this))),
                    this.$button.first().addClass(Ce.buttonActive),
                    B.promiseStylesheet().then(
                        function () {
                            this._setSlideMobile(0), this._setMobileText(0), this._setSlideshowA11y(), this.trigger("slideshow_mobile_init_done");
                        }.bind(this)
                    );
            },
            destroyMobileSlideshow: function () {
                this.trigger("slideshow_mobile_destroy"), (this.mobileSlideshow = !1), this.$container.off(this.mobileSlideshowNamespace), this.totalSlides > 1 && this.hammertime.destroy();
            },
            _onClickIndicatorDot: function (e) {
                var i = t(e.target),
                    n = i.data("slide-index");
                e.preventDefault(), ("keyup" === e.type && e.keyCode !== B.keyboardKeys.ENTER && e.keyCode !== B.keyboardKeys.SPACE) || (this._setSlideMobile(n), ("keyup" !== e.type && 0 !== e.detail) || this.$slideshow.focus());
            },
            _addKeyBindingsMobile: function (t) {
                t.which === B.keyboardKeys.LEFTARROW ? this._previousSlideMobile(t) : t.which === B.keyboardKeys.RIGHTARROW && this._nextSlideMobile(t);
            },
            _previousSlideMobile: function (e) {
                "click" === e.type && t(e.target).addClass(Ce.navigationNoFocus),
                    ("keyup" === e.type && e.keyCode !== B.keyboardKeys.ENTER && e.keyCode !== B.keyboardKeys.SPACE) || 0 === this.currentMobileSlide || this._setSlideMobile(this.currentMobileSlide - 1);
            },
            _nextSlideMobile: function (e) {
                "click" === e.type && t(e.target).addClass(Ce.navigationNoFocus),
                    ("keyup" === e.type && e.keyCode !== B.keyboardKeys.ENTER && e.keyCode !== B.keyboardKeys.SPACE) || this.currentMobileSlide === this.totalSlides - 1 || this._setSlideMobile(this.currentMobileSlide + 1);
            },
            _setSlideMobile: function (t) {
                this.currentMobileSlide !== t &&
                    ((this.xPosition = 50 * t),
                    this.$buttons.css({ transform: "translate3d(-" + this.xPosition + "%, 0, 0)" }),
                    this._setActiveStates(t),
                    this._setSlideA11y(t),
                    this._setMobileText(t),
                    (this.currentMobileSlide = t),
                    this.trigger("slideshow_set_slide", [t]),
                    this.$navigationButtons.attr("disabled", !1),
                    0 === this.currentMobileSlide && this.$navigationButtons.filter(we.previousButton).attr("disabled", !0),
                    this.currentMobileSlide === this.totalSlides - 1 && this.$navigationButtons.not(we.previousButton).attr("disabled", !0),
                    this.currentMobileSlide - 1 >= 0 && this.trigger("slideshow_previous_slide", [t - 1]),
                    this.currentMobileSlide + 1 < this.totalSlides && this.trigger("slideshow_next_slide", [t + 1]));
            },
            _setActiveStates: function (e) {
                (this.$slide = this.$slide || t(we.slide, this.$container)), (this.$button = this.$button || t(we.button, this.$container)), (this.$dot = this.$dot || t(we.indicatorDots, this.$container));
                var i = this.$slide.eq(this.currentMobileSlide),
                    n = this.$slide.eq(e);
                n.addClass(Ce.slideActive).attr("aria-hidden", !1),
                    i.addClass(Ce.slideActiveTransitioning),
                    B.promiseTransitionEnd(n).then(function () {
                        i.removeClass(Ce.slideActive).removeClass(Ce.slideActiveTransitioning).attr("aria-hidden", !0);
                    }),
                    this.$button.removeClass(Ce.buttonActive),
                    this.$button.eq(e).addClass(Ce.buttonActive),
                    this.$dot.removeClass(Ce.dotActive),
                    this.$dot.eq(e).addClass(Ce.dotActive);
            },
            _setSlideshowA11y: function () {
                (this.$labels = this.$labels || this.$button.find(we.label)),
                    (this.$ctaSingleSlide = this.$ctaSingleSlide || this.$button.find(we.ctaSingleSlide)),
                    this.$ctaSingleSlide.attr("tabindex", "0"),
                    this.$labels.attr("tabindex", "-1"),
                    this._setSlideA11y(0),
                    t.each(
                        this.$indicatorDots,
                        function (e, i) {
                            t(i).attr({ "aria-controls": "Slide" + e });
                        }.bind(this)
                    );
            },
            _setSlideA11y: function (e) {
                var i = this.$button.eq(e);
                (this.$ctasMultipleSlides = this.$ctasMultipleSlides || this.$button.find(we.ctaMultipleSlides)),
                    this.$ctasMultipleSlides && (this.$ctasMultipleSlides.attr("tabindex", "-1"), i.hasClass(Ce.linkActive) && this.$ctasMultipleSlides.eq(e).attr("tabindex", "0")),
                    t.each(
                        this.$indicatorDots,
                        function (i, n) {
                            t(n).attr({ "aria-label": this._slideLabel(e, i), "aria-current": e === i });
                        }.bind(this)
                    );
            },
            _setMobileText: function (t) {
                var e = this.$mobileTextContent.eq(t);
                if (((this.$ctaSingleSlide = this.$ctaSingleSlide || this.$button.find(we.ctaSingleSlide)), this.$ctaSingleSlide.length)) {
                    var i = (this.$ctaSingleSlide.outerHeight() - 50) / 2 + 40;
                    this.$mobileTextContent.css("padding-top", i + "px");
                }
                this.$mobileTextContent.hide(), e.show();
            },
            _slideLabel: function (t, e) {
                return (t === e ? theme.strings.slideshow.activeSlideA11yString : theme.strings.slideshow.loadSlideA11yString).replace("[slide_number]", e + 1);
            },
        },
        ke = { button: ".slideshow__button", slide: ".slideshow__slide" },
        xe = { buttonActive: "slideshow__button--active", slideActive: "slideshow__slide--active" };
    z.register("slideshow-section", {
        onLoad: function () {
            this.extend(ye),
                this.extend($e),
                this.$container.on("focusin" + this.namespace, this._onFocusIn.bind(this)),
                this.$container.on("focusout" + this.namespace, this._onFocusOut.bind(this)),
                this._toggleViewState(),
                this.window().on("resize", this._toggleViewState.bind(this));
        },
        onUnload: function () {
            this._destroyDesktopState(), this._destroyMobileState();
        },
        onBlockSelect: function (e) {
            B.promiseStylesheet().then(
                function () {
                    var i = t(e.target).index();
                    this.mobileViewEnabled ? this._setSlideMobile(i) : this._setSlideDesktop(i);
                }.bind(this)
            );
        },
        _toggleViewState: function () {
            var e,
                i,
                n = t(window).innerWidth();
            void 0 === this.mobileViewEnabled ? ((e = n < theme.mediaQuerySmall), (i = n >= theme.mediaQuerySmall)) : ((e = n < theme.mediaQuerySmall && !this.mobileViewEnabled), (i = n >= theme.mediaQuerySmall && this.mobileViewEnabled)),
                e && ((this.mobileViewEnabled = !0), this._destroyDesktopState(), this._enableMobileState()),
                i && ((this.mobileViewEnabled = !1), this._destroyMobileState(), this._enableDesktopState());
        },
        _enableDesktopState: function () {
            this.initDesktopSlideshow();
        },
        _destroyDesktopState: function () {
            this.desktopSlideshow && (this.destroyDesktopSlideshow(), this._resetSlideshowValues());
        },
        _enableMobileState: function () {
            this.initMobileSlideshow();
        },
        _destroyMobileState: function () {
            this.mobileSlideshow && (this.destroyMobileSlideshow(), this._resetSlideshowValues());
        },
        _resetSlideshowValues: function () {
            t(ke.slide).removeClass(xe.slideActive).first().addClass(xe.slideActive), t(ke.button).removeClass(xe.buttonActive).first().addClass(xe.buttonActive);
        },
        _onFocusIn: function (t) {
            (this.$container.has(t.target).length && "polite" === this.$slideshow.attr("aria-live")) || this.$slideshow.attr("aria-live", "polite");
        },
        _onFocusOut: function (t) {
            this.$container.has(t.relatedTarget).length || this.$slideshow.removeAttr("aria-live");
        },
    });
    var Te = {
            loadPlayerButton: ".video-section__load-player-button",
            closePlayerButton: ".video-section__player-close",
            playerContainer: ".video-section__player",
            cover: ".video-section__cover",
            errorMessage: ".video-section__error",
            bodyOverlay: ".video-section__body-overlay",
        },
        Pe = { playerLoading: "video-section--loading", playerLoaded: "video-section--loaded", playerError: "video-section--error", animateButton: "animated pulse" };
    z.register("video-section", {
        onLoad: function () {
            (this.$container = t(this.container)),
                this.$container.on("click", Te.loadPlayerButton, this._loadPlayer.bind(this)).on("click", Te.closePlayerButton, this._closePlayer.bind(this)).on("click", Te.bodyOverlay, this._closePlayer.bind(this));
        },
        _loadPlayer: function () {
            var e,
                i = this.$container,
                n = t(Te.loadPlayerButton, i),
                s = t(Te.playerContainer, i),
                o = this.$container.attr("data-video-type");
            return (
                n.addClass(Pe.animateButton),
                this._scrollToPlayer(i),
                "youtube" === o ? (e = this._loadYoutubePlayer(s[0])) : "vimeo" === o && (e = this._loadVimeoPlayer(s[0])),
                e
                    .then(this._onPlayerLoadReady.bind(this))
                    .catch(this._onPlayerLoadError.bind(this))
                    .always(function () {
                        n.removeClass(Pe.animateButton);
                    })
            );
        },
        _scrollToPlayer: function (e) {
            var i = e.offset().top,
                n = (t(window).height() - e.height()) / 2;
            t("html, body").animate({ scrollTop: i - Math.max(n, 0) }, 400);
        },
        _loadYoutubePlayer: function (t) {
            return Pt.promisePlayer(t, { videoId: this.$container.attr("data-video-id"), ratio: 16 / 9, playerVars: { modestbranding: 1, autoplay: 1, showinfo: 0, rel: 0 } }).then(
                function (t) {
                    this.player = t;
                }.bind(this)
            );
        },
        _loadVimeoPlayer: function (t) {
            return ve.promisePlayer(t, { id: this.$container.attr("data-video-id") }).then(
                function (t) {
                    (this.player = t), this.player.play();
                }.bind(this)
            );
        },
        _onPlayerLoadReady: function () {
            t(Te.closePlayerButton, this.$container).show().focus(),
                t(Te.cover, this.$container).prepareTransition().addClass(Pe.playerLoaded),
                this.$container.addClass(Pe.playerLoaded),
                this._setScrollPositionValues(),
                t(document)
                    .one("keyup" + this.namespace, this._closeOnEscape.bind(this))
                    .on("scroll" + this.namespace, this._onScroll.bind(this)),
                t(window).on("resize" + this.namespace, this._setScrollPositionValues.bind(this));
        },
        _onPlayerLoadError: function (e) {
            this.$container.addClass(Pe.playerError), t(Te.errorMessage, this.$container).text(e);
        },
        _closeOnEscape: function (e) {
            27 === e.keyCode && (this._closePlayer(), t(Te.loadPlayerButton, this.$container).focus());
        },
        _onScroll: function () {
            var e = t(window).scrollTop();
            (e > this.videoTop + 0.25 * this.videoHeight || e + this.windowHeight < this.videoBottom - 0.25 * this.videoHeight) && requestAnimationFrame(this._closePlayer.bind(this));
        },
        _setScrollPositionValues: function () {
            (this.videoHeight = this.$container.outerHeight(!0)), (this.videoTop = this.$container.offset().top), (this.videoBottom = this.videoTop + this.videoHeight), (this.windowHeight = t(window).innerHeight());
        },
        _closePlayer: function () {
            t(Te.cover, this.$container).prepareTransition().removeClass(Pe.playerLoaded),
                this.$container.removeClass(Pe.playerLoaded),
                t(Te.closePlayerButton, this.$container).hide(),
                "function" == typeof this.player.destroy ? this.player.destroy() : "function" == typeof this.player.unload && this.player.unload(),
                t(document).off(this.namespace),
                t(window).off(this.namespace);
        },
    }),
        (window.theme.templates = P),
        (window.theme.sections = z),
        t(document).ready(function () {
            P.load("*"), z.load("*");
        });
})(jQuery, _.omit, _.find, _.throttle, Shopify.theme.a11y, _.remove, _.filter, _.fill, _.debounce, morphdom, _.defaultTo, _.findIndex, _.isArray, Hammer);


/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isLowIE=b.isIE8=document.all&&!document.addEventListener,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(c,d){if(void 0===d||d===!1)return!0;if(e=c.split("_"),e.length>1){var f=b.find(p+"-"+e[0]);if(f.length>0){var g=e[1];"replaceWith"===g?f[0]!==d[0]&&f.replaceWith(d):"img"===g?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(p+"-"+c).html(d)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery";return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s);e.click(function(){b.prev()}),f.click(function(){b.next()}),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),A()});